<template>
  <div class="pagina ativa" id="paginaMaster">
    <div class="pagina-titulo">Master</div>

    <div v-if="masters.length > 0" class="master-cabecalho">
      <span class="master-cabecalho-nome">{{ masterAtual.nome }}</span>
      <button class="master-config-btn" @click="modalConfigMaster = true" title="Configurações do Master"><Settings :size="16" /></button>
    </div>

    <div v-if="masters.length === 0" class="card" style="text-align:center;padding:30px;">
      <p style="color:#888;margin-bottom:14px;">Você ainda não tem um Master cadastrado.</p>
      <button @click="abrirModalMaster(-1)">Criar meu Master</button>
    </div>

    <div v-else>
      <div style="display:flex;gap:8px;margin-bottom:18px;flex-wrap:wrap;">
        <button @click="aba = 'visaoGeral'" :style="abaBtn('visaoGeral')">Visão Geral</button>
        <button @click="abrirAbaCadastros" :style="abaBtn('cadastros')">Cadastros</button>
        <button @click="abrirAbaEstrutura" :style="abaBtn('estrutura')">Estrutura</button>
        <button @click="abrirAbaMapa" :style="abaBtn('mapa')">Mapa de Comissões</button>
        <button @click="aba = 'importacao'" :style="abaBtn('importacao')">Importação</button>
        <button @click="aba = 'apuracao'" :style="abaBtn('apuracao')">Apuração</button>
        <button @click="aba = 'pagamentos'" :style="abaBtn('pagamentos')">Pagamentos</button>
      </div>

      <!-- Visao Geral -->
      <div v-if="aba === 'visaoGeral'">
        <div class="visao-geral-grid">
          <div class="card"><div class="card-label">Produção</div><div class="card-valor">R$ {{ fmtNum(dashboard.producaoTotal) }}</div></div>
          <div class="card"><div class="card-label">Comissão</div><div class="card-valor" style="color:#27ae60;">R$ {{ fmtNum(dashboard.comissaoLiquida) }}</div></div>
          <div class="card"><div class="card-label">A pagar</div><div class="card-valor" style="color:#e67e22;">R$ {{ fmtNum(dashboard.totalPendente) }}</div></div>
          <div class="card"><div class="card-label">Pendências</div><div class="card-valor" :style="{ color: dashboard.linhasPendentes > 0 ? '#c0392b' : '#27ae60' }">{{ dashboard.linhasPendentes }}</div></div>
        </div>

        <div v-if="dashboard.linhasPendentes > 0 || pendenciasEstruturais.total > 0" class="card" style="margin-top:16px;border-left:4px solid #e67e22;">
          <div style="display:flex;align-items:center;gap:6px;font-weight:800;color:#c0392b;margin-bottom:8px;"><TriangleAlert :size="14" /> Atenção</div>
          <div v-if="dashboard.linhasPendentes > 0" style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;font-size:13px;border-bottom:1px solid #f0f0f0;">
            <span>{{ dashboard.linhasPendentes }} linha(s) do mapa sem empresa identificada</span>
            <button @click="abrirAbaMapa" style="margin:0;padding:5px 10px;font-size:11px;">Resolver</button>
          </div>
          <div v-if="pendenciasEstruturais.semIdentificador.length > 0" style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;font-size:13px;border-bottom:1px solid #f0f0f0;">
            <span>{{ pendenciasEstruturais.semIdentificador.length }} empresa(s) sem código Embracon vinculado</span>
            <button @click="abrirAbaCadastros(); cadastrosSubAba = 'empresas'" style="margin:0;padding:5px 10px;font-size:11px;">Resolver</button>
          </div>
          <div v-if="pendenciasEstruturais.semRegra.length > 0" style="display:flex;justify-content:space-between;align-items:center;padding:6px 0;font-size:13px;">
            <span>{{ pendenciasEstruturais.semRegra.length }} empresa(s) sem regra de comissão configurada</span>
            <button @click="abrirAbaCadastros(); cadastrosSubAba = 'empresas'" style="margin:0;padding:5px 10px;font-size:11px;">Resolver</button>
          </div>
        </div>

        <div class="card" style="margin-top:16px;">
          <div style="font-weight:800;color:#702e46;margin-bottom:10px;">Produção por empresa</div>
          <div v-for="p in dashboard.maioresProdutores" :key="p.nome" style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f0f0f0;font-size:13px;">
            <span>{{ p.nome }}</span><strong>R$ {{ fmtNum(p.total) }}</strong>
          </div>
          <div v-if="dashboard.maioresProdutores.length === 0" style="color:#aaa;text-align:center;padding:16px;">Sem dados ainda.</div>
        </div>
      </div>

      <!-- Cadastros (acesso direto, sem passar pela árvore) -->
      <div v-if="aba === 'cadastros'">
        <div style="display:flex;gap:8px;margin-bottom:14px;flex-wrap:wrap;">
          <button @click="cadastrosSubAba = 'cnpjs'" :style="abaBtnCadastros(cadastrosSubAba === 'cnpjs')">CNPJs do Master</button>
          <button @click="cadastrosSubAba = 'empresas'" :style="abaBtnCadastros(cadastrosSubAba === 'empresas')">Empresas Parceiras</button>
        </div>

        <!-- CNPJs -->
        <div v-if="cadastrosSubAba === 'cnpjs'" class="card">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
            <strong style="color:#702e46;">CNPJs do Master</strong>
            <button @click="abrirModalCnpj(-1)" style="margin:0;padding:6px 12px;font-size:12px;">+ Novo CNPJ</button>
          </div>
          <div v-for="c in cnpjs" :key="c.id" style="display:flex;justify-content:space-between;align-items:center;padding:10px 4px;border-bottom:1px solid #f2f3ef;">
            <div>
              <div style="font-weight:700;font-size:13px;">{{ c.nome }}</div>
              <div style="font-size:11px;color:#655b63;">CNPJ: {{ c.cnpj }} · Reserva MKT: {{ parseFloat(c.reserva_mkt_pct || 0) }}%</div>
            </div>
            <button @click="abrirModalCnpj(c.id)" style="margin:0;padding:6px 12px;font-size:12px;background:#eee;color:#555;">Editar</button>
          </div>
          <div v-if="cnpjs.length === 0" style="color:#aaa;text-align:center;padding:16px;">Nenhum CNPJ cadastrado.</div>
        </div>

        <!-- Empresas Parceiras -->
        <div v-if="cadastrosSubAba === 'empresas'">
          <div style="display:flex;justify-content:space-between;align-items:center;gap:10px;margin-bottom:14px;flex-wrap:wrap;">
            <strong style="color:#702e46;font-size:15px;">Empresas Parceiras</strong>
            <button @click="abrirModalEntidade(-1)" style="margin:0;padding:8px 14px;font-size:12px;">+ Nova Empresa</button>
          </div>
          <input v-model="buscaEmpresas" placeholder="Buscar empresa..." style="margin-bottom:16px;" />

          <div v-for="grupo in entidadesAgrupadasPorCnpj" :key="grupo.nome" style="margin-bottom:22px;">
            <div style="font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;color:#655b63;margin-bottom:8px;padding-left:2px;">{{ grupo.nome }} · {{ grupo.entidades.length }}</div>
            <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(270px,1fr));gap:10px;">
              <div v-for="e in grupo.entidades" :key="e.id" style="background:#fff;border:1px solid #ded6dc;border-radius:12px;padding:14px;display:flex;flex-direction:column;gap:10px;">
                <div style="display:flex;align-items:center;gap:10px;">
                  <img v-if="e.logo_url" :src="e.logo_url" style="width:40px;height:40px;object-fit:contain;background:#f7f2ee;border-radius:10px;padding:4px;flex-shrink:0;" />
                  <div v-else :style="avatarCor(e.nome_fantasia)" style="width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:13px;flex-shrink:0;">{{ iniciaisNome(e.nome_fantasia) }}</div>
                  <div style="min-width:0;">
                    <div style="font-weight:700;font-size:13px;color:#302330;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ e.nome_fantasia }}</div>
                    <div style="font-size:10px;color:#655b63;text-transform:uppercase;letter-spacing:.03em;">{{ e.tipo || 'Parceiro' }}</div>
                  </div>
                </div>
                <div style="font-size:11px;color:#655b63;background:#f7f2ee;border-radius:8px;padding:6px 9px;">{{ (identificadoresPorEntidade[e.id] || []).length }} código(s) Embracon cadastrado(s)</div>
                <div style="display:flex;gap:6px;">
                  <button @click="abrirModalEntidade(e.id, undefined, 'codigos')" style="flex:1;margin:0;padding:7px 10px;font-size:11px;background:#eee;color:#555;">Código Embracon</button>
                  <button @click="abrirModalEntidade(e.id)" style="flex:1;margin:0;padding:7px 10px;font-size:11px;background:#eee;color:#555;">Editar</button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="entidadesFiltradas.length === 0" class="card" style="color:#aaa;text-align:center;padding:24px;">Nenhuma empresa encontrada.</div>
        </div>
      </div>

      <!-- Estrutura (hierarquia) -->
      <div v-if="aba === 'estrutura'">
        <div class="est-cnpjs card">
          <div class="est-cnpjs-titulo">
            CNPJs
            <button class="est-link-btn" @click="abrirModalCnpj(-1)">+ Novo</button>
          </div>
          <div class="est-cnpjs-lista">
            <span v-for="c in cnpjs" :key="c.id" class="est-cnpj-chip" @click="abrirModalCnpj(c.id)">{{ c.nome }}</span>
            <span v-if="cnpjs.length === 0" style="color:#aaa;font-size:12px;">Nenhum CNPJ cadastrado ainda.</span>
          </div>
        </div>

        <div style="display:flex;gap:8px;margin-bottom:14px;">
          <button @click="estruturaVista = 'lista'" :style="abaBtnSecundaria('lista')">Lista</button>
          <button @click="mudarParaOrganograma" :style="abaBtnSecundaria('organograma')">Organograma</button>
        </div>

        <div v-if="estruturaVista === 'lista'" class="card">
          <div class="arvore-master">
            <span class="arvore-master-nome">{{ masterAtual.nome }}</span>
            <span class="arvore-master-label">Master</span>
          </div>
          <div class="est-arvore">
            <MasterEstruturaNo
              v-for="no in estruturaArvore"
              :key="no.id"
              :no="no"
              @editar="onEditarNo"
              @adicionar-subordinado="onAdicionarSubordinado"
              @codigo-embracon="onCodigoEmbracon"
              @configurar-comissao="onConfigurarComissao"
              @excluir="excluirEntidade"
            />
            <div v-if="estruturaArvore.length === 0" class="arvore-vazio">Nenhuma empresa com relacionamento cadastrado ainda.</div>
          </div>
          <button @click="onAdicionarSubordinado(null)" style="margin-top:14px;padding:9px 16px;font-size:13px;background:#888;">+ Adicionar empresa</button>
          <div v-if="entidadesOrfas.length > 0" class="arvore-orfas">
            <div class="arvore-orfas-titulo">Sem relacionamento cadastrado</div>
            <div v-for="e in entidadesOrfas" :key="e.id" class="arvore-orfa-item">{{ e.nome_fantasia }}</div>
          </div>
        </div>

        <div v-else class="card" style="overflow-x:auto;">
          <p style="font-size:12px;color:#888;margin:0 0 16px;">Arraste um card e solte sobre outro para mudar quem ele responde. É pedida confirmação antes de salvar.</p>
          <div class="org-wrap" ref="orgWrap">
            <svg class="org-svg" ref="orgSvg">
              <defs>
                <marker id="org-seta" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                  <path d="M0,0 L10,5 L0,10 z" fill="#aab49a" />
                </marker>
              </defs>
              <template v-for="(l, i) in orgLinhas" :key="i">
                <line :x1="l.x1" :y1="l.y1" :x2="l.x2" :y2="l.y2 - 6" stroke="#aab49a" stroke-width="1.3" marker-end="url(#org-seta)" />
                <g v-if="l.label">
                  <rect :x="(l.x1+l.x2)/2 - 16" :y="(l.y1+l.y2)/2 - 8" width="32" height="14" rx="3" fill="#faf7ee" stroke="#e3dcc2" stroke-width="1" />
                  <text :x="(l.x1+l.x2)/2" :y="(l.y1+l.y2)/2 + 2" text-anchor="middle" font-size="9" font-weight="700" fill="#8a6d1d">{{ l.label }}</text>
                </g>
              </template>
            </svg>
            <div class="org-item">
              <div class="org-box org-box-master" data-org-box data-entidade-id="master-root" @dragover.prevent @drop="onSoltarNoRoot">
                <div class="org-nome">{{ masterAtual.nome }}</div>
                <div class="org-tipo">Master</div>
              </div>
              <div v-if="organogramaArvore.length" class="org-filhos">
                <MasterOrganogramaNo v-for="no in organogramaArvore" :key="no.id" :no="no" pai-id="master-root" @soltar="onSoltarNoGrafo" @abrir-acoes="abrirMenuRapido" />
              </div>
            </div>
          </div>
          <div v-if="entidadesOrfas.length > 0" class="arvore-orfas">
            <div class="arvore-orfas-titulo">Sem relacionamento cadastrado</div>
            <div v-for="e in entidadesOrfas" :key="e.id" class="arvore-orfa-item">{{ e.nome_fantasia }}</div>
          </div>
        </div>
      </div>

      <!-- Menu rapido do organograma -->
      <Teleport to="body">
      <div v-if="menuRapido.aberto" class="master-modal-overlay" @click.self="menuRapido.aberto = false">
        <div class="master-modal" style="max-width:280px;">
          <h3 style="margin-bottom:4px;">{{ menuRapido.no.nome }}</h3>
          <p style="font-size:11px;color:#888;margin:0 0 14px;">{{ menuRapido.no.tipoEntidade }}</p>
          <div style="display:flex;flex-direction:column;gap:8px;">
            <button @click="menuRapido.aberto = false; onEditarNo(menuRapido.no)">Editar</button>
            <button @click="menuRapido.aberto = false; onAdicionarSubordinado(menuRapido.no)" style="background:#888;">Adicionar subordinado</button>
            <button @click="menuRapido.aberto = false; onCodigoEmbracon(menuRapido.no)" style="background:#2980b9;">Código Embracon</button>
            <button @click="menuRapido.aberto = false; onConfigurarComissao(menuRapido.no)" style="background:#702e46;">Configurar comissão</button>
          </div>
          <div class="master-modal-acoes">
            <button @click="menuRapido.aberto = false" style="background:#eee;color:#555;">Fechar</button>
          </div>
        </div>
      </div>
      </Teleport>

      <!-- Mapa de Comissoes (conferencia sem precisar do Excel) -->
      <div v-if="aba === 'mapa'">
        <div v-if="lotes.length === 0" style="color:#aaa;text-align:center;padding:30px;">Nenhum mapa importado ainda. Vá em "Importação" pra subir o primeiro.</div>
        <div v-else>
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;flex-wrap:wrap;gap:10px;">
            <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
              <label style="font-size:12px;color:#655b63;font-weight:700;">Lote:</label>
              <select v-model.number="mapaSelecionado" @change="carregarLinhasMapa" style="width:auto;">
                <option v-for="l in lotes" :key="l.id" :value="l.id">{{ l.arquivo }}{{ l.competencia ? ' · ' + l.competencia : '' }}</option>
              </select>
            </div>
            <div style="display:flex;gap:8px;">
              <button v-if="loteAtualMapa.status === 'APURADO'" @click="verApuracao(loteAtualMapa)" style="margin:0;padding:7px 12px;font-size:12px;background:#2980b9;">Ver Apuração</button>
              <button v-if="mapaSelecionado" @click="reprocessarReconhecimentoMapa" style="margin:0;padding:7px 12px;font-size:12px;background:#eee;color:#555;">↻ Reprocessar reconhecimento</button>
            </div>
          </div>

          <!-- Faixa de indicadores -->
          <div v-if="mapaSelecionado" style="background:#fff;border:1px solid #ded6dc;border-radius:12px;padding:14px 18px;display:flex;align-items:stretch;margin-bottom:12px;flex-wrap:wrap;gap:10px;">
            <div style="flex:1;min-width:110px;padding-right:14px;border-right:1px solid #ded6dc;">
              <div style="font-size:10px;color:#655b63;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;">Comissão</div>
              <div style="font-size:18px;font-weight:800;color:#302330;">R$ {{ fmtNum(mapaTotaisFiltrados.comissao) }}</div>
            </div>
            <div style="flex:1;min-width:110px;padding:0 14px;border-right:1px solid #ded6dc;">
              <div style="font-size:10px;color:#655b63;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;">Estornos</div>
              <div style="font-size:18px;font-weight:800;color:#c2413b;">R$ {{ fmtNum(mapaTotaisFiltrados.estorno) }}</div>
            </div>
            <div style="flex:1;min-width:110px;padding:0 14px;border-right:1px solid #ded6dc;">
              <div style="font-size:10px;color:#655b63;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;">Cancelamentos</div>
              <div style="font-size:18px;font-weight:800;color:#c2413b;">R$ {{ fmtNum(mapaTotaisFiltrados.cancelamento) }}</div>
            </div>
            <div style="flex:1;min-width:110px;padding:0 14px;border-right:1px solid #ded6dc;">
              <div style="font-size:10px;color:#655b63;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;">Líquido</div>
              <div style="font-size:18px;font-weight:800;color:#3f7a52;">R$ {{ fmtNum(mapaTotaisFiltrados.liquido) }}</div>
            </div>
            <div style="flex:1;min-width:90px;padding:0 14px;border-right:1px solid #ded6dc;">
              <div style="font-size:10px;color:#655b63;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;">Registros</div>
              <div style="font-size:18px;font-weight:800;color:#302330;">{{ mapaLinhasFiltradas.length }}</div>
            </div>
            <div style="flex:1;min-width:90px;padding-left:14px;">
              <div style="font-size:10px;color:#655b63;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px;">Pendências</div>
              <div style="font-size:18px;font-weight:800;" :style="{color: mapaPendenciasCount > 0 ? '#d97706' : '#3f7a52'}">{{ mapaPendenciasCount }}</div>
            </div>
          </div>
          <div v-if="mapaSelecionado && mapaLinhasFiltradas.length !== mapaLinhas.length" style="font-size:11px;color:#655b63;margin:-6px 0 12px;">Mostrando totais filtrados ({{ mapaLinhasFiltradas.length }} de {{ mapaLinhas.length }} registros). <a href="#" @click.prevent="limparFiltrosMapa" style="color:#702e46;font-weight:700;">Limpar filtros</a> pra ver o total do lote inteiro.</div>

          <!-- Barra de ferramentas -->
          <div v-if="mapaSelecionado" style="background:#fff;border:1px solid #ded6dc;border-radius:12px;padding:10px 14px;display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:12px;">
            <input v-model="mapaBusca" placeholder="Buscar contrato, consorciado, vendedor ou código Embracon..." style="margin:0;flex:1;min-width:220px;" />
            <select v-model="mapaFiltroEmpresaNome" style="width:auto;margin:0;">
              <option value="">Empresa: todas</option>
              <option v-for="n in mapaEmpresasDisponiveis" :key="n" :value="n">{{ n }}</option>
            </select>
            <select v-model="mapaFiltroSituacao" style="width:auto;margin:0;">
              <option value="">Situação: todas</option>
              <option value="recebida">Recebida</option>
              <option value="estornado">Estornado</option>
              <option value="cancelado">Cancelado</option>
            </select>
            <select v-model="mapaFiltroParcela" style="width:auto;margin:0;">
              <option value="">Parcela: todas</option>
              <option value="1">1ª parcela</option>
              <option value="2+">2ª parcela +</option>
            </select>
            <select v-model="mapaFiltroIdentificacao" style="width:auto;margin:0;">
              <option value="identificadas">Identificação: identificadas</option>
              <option value="nao_identificadas">Identificação: não identificadas</option>
              <option value="todas">Identificação: todas</option>
            </select>
            <label style="display:flex;align-items:center;gap:5px;font-size:12px;color:#544b54;white-space:nowrap;">
              <input type="checkbox" v-model="mapaIncluirNaoIdentificadasNaSoma" style="width:auto;margin:0;" />
              Considerar não identificadas na soma
            </label>
            <button @click="limparFiltrosMapa" style="margin:0;padding:7px 12px;font-size:12px;background:transparent;color:#655b63;border:1px solid #ded6dc;">Limpar filtros</button>
            <div style="flex:1;min-width:8px;"></div>
            <div style="display:flex;border:1px solid #ded6dc;border-radius:8px;overflow:hidden;">
              <button @click="mapaVista = 'empresa'" style="margin:0;padding:7px 12px;font-size:12px;font-weight:700;border-radius:0;" :style="{background: mapaVista === 'empresa' ? '#702e46' : '#fff', color: mapaVista === 'empresa' ? '#fff' : '#544b54'}">Por empresa</button>
              <button @click="mapaVista = 'contratos'" style="margin:0;padding:7px 12px;font-size:12px;font-weight:700;border-radius:0;border-left:1px solid #ded6dc;" :style="{background: mapaVista === 'contratos' ? '#702e46' : '#fff', color: mapaVista === 'contratos' ? '#fff' : '#544b54'}">Todos os contratos</button>
              <button @click="mapaVista = 'vendedor'" style="margin:0;padding:7px 12px;font-size:12px;font-weight:700;border-radius:0;border-left:1px solid #ded6dc;" :style="{background: mapaVista === 'vendedor' ? '#702e46' : '#fff', color: mapaVista === 'vendedor' ? '#fff' : '#544b54'}">Por vendedor</button>
            </div>
          </div>

          <!-- Vista: por empresa (resumo + pendências de identificação) -->
          <div v-if="mapaSelecionado && mapaVista === 'empresa'" class="card" style="overflow-x:auto;">
            <input v-model="buscaMapaEmpresa" placeholder="Buscar empresa..." style="margin-bottom:10px;" />
            <table style="width:100%;border-collapse:collapse;font-size:12px;">
              <thead>
                <tr style="border-bottom:2px solid #e8e8e2;text-align:right;">
                  <th style="text-align:left;padding:6px 4px;">Empresa</th>
                  <th style="padding:6px 4px;">Registros</th>
                  <th style="padding:6px 4px;">Comissão</th>
                  <th style="padding:6px 4px;">Estornos</th>
                  <th style="padding:6px 4px;">Cancelamentos</th>
                  <th style="padding:6px 4px;">Líquido</th>
                  <th style="padding:6px 4px;text-align:left;">Situação</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="g in mapaResumoPorEmpresaFiltrado" :key="g.chave" style="border-bottom:1px solid #f2f3ef;text-align:right;">
                  <td style="text-align:left;padding:6px 4px;font-weight:700;">{{ g.nome }}</td>
                  <td style="padding:6px 4px;">{{ g.registros }}</td>
                  <td style="padding:6px 4px;">R$ {{ fmtNum(g.comissao) }}</td>
                  <td style="padding:6px 4px;color:#c0392b;">R$ {{ fmtNum(g.estorno) }}</td>
                  <td style="padding:6px 4px;color:#c0392b;">R$ {{ fmtNum(g.cancelamento) }}</td>
                  <td style="padding:6px 4px;font-weight:700;">R$ {{ fmtNum(g.liquido) }}</td>
                  <td style="text-align:left;padding:6px 4px;">
                    <span v-if="g.cadastrada" style="font-size:11px;background:#e8f5e9;color:#2e7d32;padding:2px 8px;border-radius:8px;">Cadastrada</span>
                    <span v-else style="font-size:11px;background:#fde8e8;color:#c0392b;padding:2px 8px;border-radius:8px;">Não cadastrada</span>
                  </td>
                  <td style="padding:6px 4px;">
                    <button v-if="g.cadastrada" @click="abrirDetalheEmpresaMapa(g)" style="margin:0;padding:5px 10px;font-size:11px;background:#eee;color:#555;">Ver contratos →</button>
                  </td>
                </tr>
                <tr v-for="g in mapaResumoPorEmpresaFiltrado.filter(x => !x.cadastrada)" :key="g.chave + '-acao'" style="border-bottom:1px solid #f2f3ef;background:#fff8f0;">
                  <td colspan="8" style="padding:8px 4px;">
                    <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:12px;">
                      <span style="color:#8a6d1d;">↳ {{ g.nome }} ({{ g.registros }} linha(s), R$ {{ fmtNum(g.liquido) }}):</span>
                      <select v-model.number="mapaVincularSelecao[g.chave]" style="width:auto;margin:0;padding:5px 8px;font-size:12px;">
                        <option :value="null">Vincular a empresa existente...</option>
                        <option v-for="e in entidades" :key="e.id" :value="e.id">{{ e.nome_fantasia }}</option>
                      </select>
                      <button @click="vincularGrupoMapa(g)" :disabled="!mapaVincularSelecao[g.chave]" style="margin:0;padding:5px 10px;font-size:11px;background:#27ae60;">Vincular</button>
                      <button @click="abrirModalEntidade(-1)" style="margin:0;padding:5px 10px;font-size:11px;background:#eee;color:#555;">+ Cadastrar nova empresa</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Vista: todos os contratos (tabela analítica) -->
          <div v-if="mapaSelecionado && mapaVista === 'contratos'" style="background:#fff;border:1px solid #ded6dc;border-radius:12px;overflow:hidden;">
            <div style="overflow-x:auto;">
              <table style="width:100%;min-width:1100px;border-collapse:collapse;font-size:12px;">
                <thead>
                  <tr style="background:#302330;">
                    <th @click="ordenarMapaPor('empresa')" style="cursor:pointer;text-align:left;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Empresa{{ iconeOrdenacaoMapa('empresa') }}</th>
                    <th style="text-align:left;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Cód. Embracon</th>
                    <th style="text-align:left;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Contrato</th>
                    <th style="text-align:left;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Consorciado</th>
                    <th style="text-align:left;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Vendedor</th>
                    <th style="text-align:center;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Parcela</th>
                    <th @click="ordenarMapaPor('comissao')" style="cursor:pointer;text-align:right;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Comissão{{ iconeOrdenacaoMapa('comissao') }}</th>
                    <th style="text-align:right;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Estorno</th>
                    <th style="text-align:right;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Cancel.</th>
                    <th @click="ordenarMapaPor('liquido')" style="cursor:pointer;text-align:right;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Líquido{{ iconeOrdenacaoMapa('liquido') }}</th>
                    <th style="text-align:left;padding:8px 10px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#fff;white-space:nowrap;">Situação</th>
                    <th style="width:28px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="l in mapaLinhasPaginadas" :key="l.id">
                  <tr style="border-bottom:1px solid #ded6dc;" :style="{background: !l.entidade_id ? '#fdf1e2' : 'transparent'}">
                    <td style="padding:8px 10px;font-weight:700;color:#302330;">{{ l._empresaNome }}</td>
                    <td style="padding:8px 10px;color:#655b63;">{{ l._codigoEmbracon || '—' }}</td>
                    <td style="padding:8px 10px;color:#544b54;">{{ l.contrato }}</td>
                    <td style="padding:8px 10px;color:#544b54;">{{ l.nome_consorciado }}</td>
                    <td style="padding:8px 10px;color:#544b54;">{{ l.vendedor }}</td>
                    <td style="padding:8px 10px;text-align:center;color:#655b63;">{{ l.parcela }}</td>
                    <td style="padding:8px 10px;text-align:right;color:#302330;font-weight:600;">R$ {{ fmtNum(l._comissao) }}</td>
                    <td style="padding:8px 10px;text-align:right;color:#a79aa5;">{{ l._estorno > 0 ? 'R$ ' + fmtNum(l._estorno) : '—' }}</td>
                    <td style="padding:8px 10px;text-align:right;color:#a79aa5;">{{ l._cancelamento > 0 ? 'R$ ' + fmtNum(l._cancelamento) : '—' }}</td>
                    <td style="padding:8px 10px;text-align:right;font-weight:700;color:#302330;">R$ {{ fmtNum(l._liquido) }}</td>
                    <td style="padding:8px 10px;">
                      <span v-if="!l.entidade_id" :style="situacaoMapaTag('pendente')" style="background:#fdf1e2;color:#d97706;">Sem regra</span>
                      <span v-else :style="situacaoMapaTag(l._situacao)">{{ l._situacao === 'cancelado' ? 'Cancelado' : l._situacao === 'estornado' ? 'Estornado' : 'Recebida' }}</span>
                    </td>
                    <td style="padding:8px 8px;text-align:center;color:#a79aa5;cursor:pointer;" @click="alternarExpansaoLinhaMapa(l)">
                      <ChevronDown v-if="mapaLinhaExpandidaId === l.id" :size="14" style="display:inline-block;vertical-align:middle;" />
                      <ChevronRight v-else :size="14" style="display:inline-block;vertical-align:middle;" />
                    </td>
                  </tr>
                  <tr v-if="mapaLinhaExpandidaId === l.id" style="background:#faf7f2;border-bottom:1px solid #ded6dc;">
                    <td colspan="11" style="padding:12px 16px;">
                      <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px 18px;font-size:12px;max-width:760px;">
                        <div><div style="color:#655b63;font-size:10px;text-transform:uppercase;margin-bottom:2px;">Data da venda</div><div style="color:#302330;font-weight:600;">{{ l.data_venda || '—' }}</div></div>
                        <div><div style="color:#655b63;font-size:10px;text-transform:uppercase;margin-bottom:2px;">Categoria</div><div style="color:#302330;font-weight:600;">{{ l.categoria || '—' }}</div></div>
                        <div><div style="color:#655b63;font-size:10px;text-transform:uppercase;margin-bottom:2px;">Status cota</div><div style="color:#302330;font-weight:600;">{{ l.status_cota || '—' }}</div></div>
                        <div><div style="color:#655b63;font-size:10px;text-transform:uppercase;margin-bottom:2px;">Base de cálculo</div><div style="color:#302330;font-weight:600;">R$ {{ fmtNum(l.base_calc_comissao) }}</div></div>
                      </div>
                    </td>
                  </tr>
                  </template>
                </tbody>
                <tfoot>
                  <tr style="border-top:2px solid #302330;">
                    <td colspan="6" style="padding:9px 10px;font-weight:800;color:#302330;font-size:11px;text-transform:uppercase;letter-spacing:.03em;">Total filtrado · {{ mapaLinhasFiltradas.length }} de {{ mapaLinhas.length }} registros</td>
                    <td style="padding:9px 10px;text-align:right;font-weight:800;color:#302330;">R$ {{ fmtNum(mapaTotaisFiltrados.comissao) }}</td>
                    <td style="padding:9px 10px;text-align:right;font-weight:800;color:#c2413b;">R$ {{ fmtNum(mapaTotaisFiltrados.estorno) }}</td>
                    <td style="padding:9px 10px;text-align:right;font-weight:800;color:#c2413b;">R$ {{ fmtNum(mapaTotaisFiltrados.cancelamento) }}</td>
                    <td style="padding:9px 10px;text-align:right;font-weight:800;color:#3f7a52;">R$ {{ fmtNum(mapaTotaisFiltrados.liquido) }}</td>
                    <td colspan="2"></td>
                  </tr>
                </tfoot>
              </table>
              <div v-if="mapaLinhasFiltradas.length === 0" style="color:#aaa;text-align:center;padding:24px;">Nenhum contrato encontrado com esses filtros.</div>
            </div>
            <div v-if="mapaLinhasFiltradas.length > 0" style="display:flex;align-items:center;justify-content:space-between;padding:9px 14px;border-top:1px solid #ded6dc;">
              <div style="display:flex;align-items:center;gap:8px;font-size:12px;color:#655b63;">
                <span>Linhas por página</span>
                <select v-model.number="mapaLinhasPorPagina" style="width:auto;margin:0;padding:5px 8px;font-size:12px;">
                  <option :value="25">25</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>
              <div style="display:flex;align-items:center;gap:6px;">
                <button @click="mudarPaginaMapa(-1)" :disabled="mapaPaginaAtual <= 1" style="margin:0;width:28px;height:28px;padding:0;font-size:12px;background:#fff;color:#544b54;border:1px solid #ded6dc;">‹</button>
                <span style="font-size:12px;color:#544b54;">Página {{ mapaPaginaAtual }} de {{ mapaTotalPaginas }}</span>
                <button @click="mudarPaginaMapa(1)" :disabled="mapaPaginaAtual >= mapaTotalPaginas" style="margin:0;width:28px;height:28px;padding:0;font-size:12px;background:#fff;color:#544b54;border:1px solid #ded6dc;">›</button>
              </div>
            </div>
          </div>

          <!-- Vista: por vendedor -->
          <div v-if="mapaSelecionado && mapaVista === 'vendedor'" class="card" style="overflow-x:auto;">
            <table style="width:100%;border-collapse:collapse;font-size:12px;">
              <thead>
                <tr style="border-bottom:2px solid #e8e8e2;text-align:right;">
                  <th style="text-align:left;padding:6px 4px;">Vendedor</th>
                  <th style="padding:6px 4px;">Registros</th>
                  <th style="padding:6px 4px;">Comissão</th>
                  <th style="padding:6px 4px;">Estornos</th>
                  <th style="padding:6px 4px;">Cancelamentos</th>
                  <th style="padding:6px 4px;">Líquido</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="v in resumoPorVendedorMapa" :key="v.vendedor" style="border-bottom:1px solid #f2f3ef;text-align:right;">
                  <td style="text-align:left;padding:6px 4px;">{{ v.vendedor }}</td>
                  <td style="padding:6px 4px;">{{ v.registros }}</td>
                  <td style="padding:6px 4px;">R$ {{ fmtNum(v.comissao) }}</td>
                  <td style="padding:6px 4px;color:#c0392b;">R$ {{ fmtNum(v.estorno) }}</td>
                  <td style="padding:6px 4px;color:#c0392b;">R$ {{ fmtNum(v.cancelamento) }}</td>
                  <td style="padding:6px 4px;font-weight:700;">R$ {{ fmtNum(v.liquido) }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="resumoPorVendedorMapa.length === 0" style="color:#aaa;text-align:center;padding:16px;">Nenhum vendedor encontrado com esses filtros.</div>
          </div>
        </div>
      </div>

      <!-- Importacao -->
      <div v-if="aba === 'importacao'">
        <div class="card" style="margin-bottom:16px;">
          <div style="font-weight:800;color:#702e46;margin-bottom:10px;">Importar mapa de comissão Embracon</div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px;">
            <div>
              <label>CNPJ *</label>
              <select v-model.number="importForm.masterCnpjId">
                <option :value="null">Selecione o CNPJ deste arquivo...</option>
                <option v-for="c in cnpjs" :key="c.id" :value="c.id">{{ c.nome }}</option>
              </select>
            </div>
            <div><label>COMPETÊNCIA</label><input type="text" v-model="importForm.competencia" placeholder="Ex: 2026-09" /></div>
          </div>
          <div class="area-upload" @click="$refs.inputMapa.click()" style="margin-bottom:10px;">
            <div>{{ importForm.nomeArquivo || 'Selecionar planilha (.xlsx)' }}</div>
          </div>
          <input type="file" ref="inputMapa" accept=".xlsx,.xls" style="display:none;" @change="selecionarMapa" />
          <button :disabled="!importForm.dados || !importForm.masterCnpjId || importando" @click="importarMapa" style="width:100%;">{{ importando ? 'Importando...' : 'Importar' }}</button>
          <div v-if="importStatus" class="status" :class="importStatusClasse">{{ importStatus }}</div>
        </div>

        <div v-if="lotes.length === 0" style="color:#aaa;text-align:center;padding:20px;">Nenhum lote importado ainda.</div>
        <div v-for="l in lotes" :key="l.id" class="card" style="margin-bottom:10px;">
          <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;">
            <div style="font-size:13px;">
              <strong>{{ l.arquivo }}</strong>
              <span v-if="l.competencia" style="color:#888;"> · {{ l.competencia }}</span>
              <div style="color:#888;margin-top:2px;">{{ l.cnpj_nome }} · {{ l.total_linhas }} linhas · R$ {{ fmtNum(l.valor_total) }}</div>
              <span v-if="l.pendentes > 0" style="display:inline-block;margin-top:5px;font-size:11px;background:#fff8e1;color:#8a6d1d;padding:2px 8px;border-radius:8px;">{{ l.pendentes }} pendente(s) de identificação</span>
              <span v-else style="display:inline-block;margin-top:5px;font-size:11px;background:#e8f5e9;color:#2e7d32;padding:2px 8px;border-radius:8px;">Todas identificadas</span>
              <span v-if="l.fora_condicao > 0" style="display:inline-block;margin-top:5px;margin-left:5px;font-size:11px;background:#fde8e8;color:#c0392b;padding:2px 8px;border-radius:8px;cursor:pointer;" @click="abrirForaCondicao(l)">{{ l.fora_condicao }} fora da condição comercial</span>
            </div>
            <div style="display:flex;gap:6px;flex-shrink:0;">
              <button v-if="l.pendentes > 0" @click="abrirInconsistencias(l)" style="margin:0;padding:7px 12px;font-size:12px;background:#e67e22;">Resolver</button>
              <button v-if="!apuracoes.some(a => a.mapa_id === l.id)" @click="apurarLote(l)" style="margin:0;padding:7px 12px;font-size:12px;background:#27ae60;">Apurar{{ l.pendentes > 0 ? ' mesmo assim' : '' }}</button>
              <button v-else @click="verApuracao(l)" style="margin:0;padding:7px 12px;font-size:12px;background:#2980b9;">Ver Apuração</button>
              <button @click="excluirLote(l)" style="margin:0;padding:7px 12px;font-size:12px;background:#c0392b;">Excluir</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Apuracao -->
      <div v-if="aba === 'apuracao'">
        <div v-if="apuracoes.length > 0" class="visao-geral-grid" style="margin-bottom:16px;">
          <div class="card"><div class="card-label">Apurações</div><div class="card-valor">{{ apuracoes.length }}</div></div>
          <div class="card"><div class="card-label">Bruto total</div><div class="card-valor">R$ {{ fmtNum(apuracoes.reduce((s,a) => s + parseFloat(a.valor_total || 0), 0)) }}</div></div>
          <div class="card"><div class="card-label">Imposto total</div><div class="card-valor" style="color:#c0392b;">R$ {{ fmtNum(apuracoes.reduce((s,a) => s + (parseFloat(a.valor_total || 0) - parseFloat(a.valor_total_liquido || 0)), 0)) }}</div></div>
          <div class="card"><div class="card-label">Líquido total</div><div class="card-valor" style="color:#27ae60;">R$ {{ fmtNum(apuracoes.reduce((s,a) => s + parseFloat(a.valor_total_liquido || 0), 0)) }}</div></div>
        </div>
        <div v-if="apuracoes.length === 0" style="color:#aaa;text-align:center;padding:30px;">Nenhuma apuração ainda. Importe e apure um lote na aba Importação.</div>
        <div v-for="a in apuracoes" :key="a.id" class="card" style="margin-bottom:10px;display:flex;justify-content:space-between;align-items:center;gap:10px;">
          <div style="font-size:13px;">
            <strong>{{ a.arquivo }}</strong>
            <span v-if="a.competencia" style="color:#888;"> · {{ a.competencia }}</span>
            <span style="display:inline-block;margin-left:6px;font-size:11px;background:#e8f5e9;color:#2e7d32;padding:2px 8px;border-radius:8px;">{{ a.status }}</span>
            <div style="font-size:17px;font-weight:900;color:#302330;margin-top:4px;">R$ {{ fmtNum(a.valor_total_liquido) }} <span style="font-size:11px;font-weight:600;color:#888;">líquido</span></div>
            <div style="font-size:11px;color:#888;">Bruto: R$ {{ fmtNum(a.valor_total) }} · Imposto: R$ {{ fmtNum(parseFloat(a.valor_total || 0) - parseFloat(a.valor_total_liquido || 0)) }}</div>
          </div>
          <button @click="verApuracaoDireto(a)" style="margin:0;padding:7px 12px;font-size:12px;background:#2980b9;">Ver</button>
        </div>

        <div v-if="lotesNaoApurados.length > 0" style="margin-top:22px;">
          <div style="font-weight:800;color:#8a6d1d;margin-bottom:10px;">Mapas ainda não apurados</div>
          <div v-for="l in lotesNaoApurados" :key="l.id" class="card" style="margin-bottom:10px;display:flex;justify-content:space-between;align-items:center;gap:10px;">
            <div style="font-size:13px;">
              <strong>{{ l.arquivo }}</strong>
              <span v-if="l.competencia" style="color:#888;"> · {{ l.competencia }}</span>
              <div style="color:#888;margin-top:2px;">{{ l.cnpj_nome }} · {{ l.total_linhas }} linhas · R$ {{ fmtNum(l.valor_total) }}</div>
              <span v-if="l.pendentes > 0" style="display:inline-block;margin-top:5px;font-size:11px;background:#fff8e1;color:#8a6d1d;padding:2px 8px;border-radius:8px;">{{ l.pendentes }} pendente(s) de identificação</span>
              <span v-else style="display:inline-block;margin-top:5px;font-size:11px;background:#e8f5e9;color:#2e7d32;padding:2px 8px;border-radius:8px;">Todas identificadas</span>
            </div>
            <div style="display:flex;gap:6px;flex-shrink:0;">
              <button v-if="l.pendentes > 0" @click="abrirInconsistencias(l)" style="margin:0;padding:7px 12px;font-size:12px;background:#e67e22;">Resolver pendências</button>
              <button v-if="!apuracoes.some(a => a.mapa_id === l.id)" @click="apurarLote(l)" style="margin:0;padding:7px 12px;font-size:12px;background:#27ae60;">Apurar{{ l.pendentes > 0 ? ' mesmo assim' : '' }}</button>
              <button v-else @click="verApuracao(l)" style="margin:0;padding:7px 12px;font-size:12px;background:#2980b9;">Ver Apuração</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagamentos -->
      <div v-if="aba === 'pagamentos'">
        <div style="display:flex;align-items:center;gap:8px;margin-bottom:14px;flex-wrap:wrap;">
          <label style="font-size:12px;color:#655b63;font-weight:700;">Mapa:</label>
          <select v-model.number="pagamentosFiltroMapa" @change="carregarPagamentos" style="width:auto;margin:0;">
            <option :value="null">Todos os mapas</option>
            <option v-for="l in lotes" :key="l.id" :value="l.id">{{ l.arquivo }}{{ l.competencia ? ' · ' + l.competencia : '' }}</option>
          </select>
        </div>
        <div v-if="pagamentos.length > 0" class="visao-geral-grid" style="margin-bottom:14px;">
          <div class="card"><div class="card-label">Beneficiários</div><div class="card-valor">{{ pagamentos.length }}</div></div>
          <div class="card"><div class="card-label">Bruto</div><div class="card-valor">R$ {{ fmtNum(pagamentos.reduce((s,p) => s + parseFloat(p.valor_bruto || p.valor || 0), 0)) }}</div></div>
          <div class="card"><div class="card-label">Imposto</div><div class="card-valor" style="color:#c0392b;">R$ {{ fmtNum(pagamentos.reduce((s,p) => s + (parseFloat(p.valor_bruto || p.valor || 0) - parseFloat(p.valor || 0)), 0)) }}</div></div>
          <div class="card"><div class="card-label">Líquido</div><div class="card-valor" style="color:#27ae60;">R$ {{ fmtNum(pagamentos.reduce((s,p) => s + parseFloat(p.valor || 0), 0)) }}</div></div>
        </div>
        <div v-if="pagamentos.length > 0" style="display:flex;gap:8px;margin-bottom:14px;">
          <button @click="pagamentosVista = 'cards'" :style="abaBtnSecundaria2('cards')">Cartões</button>
          <button @click="pagamentosVista = 'resumo'" :style="abaBtnSecundaria2('resumo')">Resumo</button>
        </div>

        <div v-if="pagamentos.length === 0" style="color:#aaa;text-align:center;padding:30px;">Nenhum pagamento gerado ainda. Apure um lote e clique em "Gerar Pagamentos".</div>

        <div v-else-if="pagamentosVista === 'resumo'">
          <div v-for="grupo in pagamentosPorCompetencia" :key="grupo.competencia" class="card" style="margin-bottom:14px;overflow-x:auto;">
            <div style="font-weight:800;color:#702e46;margin-bottom:10px;">{{ grupo.competencia || 'Sem competência' }}</div>
            <table style="width:100%;border-collapse:collapse;font-size:12px;">
              <thead>
                <tr style="border-bottom:2px solid #e8e8e2;text-align:right;">
                  <th style="text-align:left;padding:6px 4px;">Beneficiário</th>
                  <th style="text-align:left;padding:6px 4px;">Empresa</th>
                  <th style="padding:6px 4px;">Bruto</th>
                  <th style="padding:6px 4px;">Imposto</th>
                  <th style="padding:6px 4px;">Líquido</th>
                  <th style="padding:6px 4px;text-align:left;">Status</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="p in grupo.itens" :key="p.id">
                <tr style="border-bottom:1px solid #f2f3ef;text-align:right;">
                  <td style="text-align:left;padding:6px 4px;">{{ p.beneficiario_nome }}</td>
                  <td style="text-align:left;padding:6px 4px;color:#655b63;">{{ p.empresas || '—' }}<span v-if="p.cnpjs" style="display:block;font-size:10px;color:#655b63;">{{ p.cnpjs }}</span></td>
                  <td style="padding:6px 4px;">R$ {{ fmtNum(p.valor_bruto || p.valor) }}</td>
                  <td style="padding:6px 4px;color:#c0392b;">R$ {{ fmtNum((p.valor_bruto || p.valor) - p.valor) }}</td>
                  <td style="padding:6px 4px;font-weight:700;">R$ {{ fmtNum(p.valor) }}</td>
                  <td style="text-align:left;padding:6px 4px;"><span :style="statusPagTag(p.status)">{{ p.status }}</span></td>
                </tr>
                <tr v-for="pe in p.porEmpresa" :key="p.id + '-' + pe.empresa" style="border-bottom:1px solid #f7f2ee;text-align:right;background:#fbfbf9;">
                  <td></td>
                  <td style="text-align:left;padding:3px 4px 3px 16px;font-size:11px;color:#655b63;">↳ {{ pe.empresa }}</td>
                  <td style="padding:3px 4px;font-size:11px;color:#655b63;">R$ {{ fmtNum(pe.bruto) }}</td>
                  <td style="padding:3px 4px;font-size:11px;color:#c0a0a0;">R$ {{ fmtNum(pe.imposto) }}</td>
                  <td style="padding:3px 4px;font-size:11px;color:#655b63;">R$ {{ fmtNum(pe.liquido) }}</td>
                  <td></td>
                </tr>
                </template>
              </tbody>
              <tfoot>
                <tr style="border-top:2px solid #702e46;font-weight:800;text-align:right;">
                  <td style="text-align:left;padding:8px 4px;">TOTAL</td>
                  <td></td>
                  <td style="padding:8px 4px;">R$ {{ fmtNum(grupo.totalBruto) }}</td>
                  <td style="padding:8px 4px;color:#c0392b;">R$ {{ fmtNum(grupo.totalImposto) }}</td>
                  <td style="padding:8px 4px;color:#302330;">R$ {{ fmtNum(grupo.totalLiquido) }}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div v-else>
        <div v-for="p in pagamentos" :key="p.id" class="card" style="margin-bottom:12px;padding:0;overflow:hidden;">
          <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:16px;">
            <div style="display:flex;gap:12px;align-items:flex-start;">
              <div style="width:44px;height:44px;border-radius:50%;background:#efe3e8;color:#702e46;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:15px;flex-shrink:0;">{{ iniciaisNome(p.beneficiario_nome) }}</div>
              <div>
                <strong style="font-size:14px;">{{ p.beneficiario_nome }}</strong>
                <span :style="statusPagTag(p.status)">{{ p.status }}</span>
                <div style="color:#655b63;font-size:11px;margin-top:3px;">{{ p.empresas || '—' }}</div>
                <div style="color:#888;font-size:11px;">{{ p.competencia || '—' }} <span v-if="p.pix_chave">· PIX: {{ p.pix_chave }}</span></div>
              </div>
            </div>
            <div style="text-align:right;flex-shrink:0;">
              <div style="font-size:20px;font-weight:900;color:#302330;">R$ {{ fmtNum(p.valor) }}</div>
              <div v-if="p.valor_bruto && p.valor_bruto !== p.valor" style="font-size:11px;color:#888;">Bruto R$ {{ fmtNum(p.valor_bruto) }} · Imposto R$ {{ fmtNum(p.valor_bruto - p.valor) }}</div>
            </div>
          </div>
          <div v-if="p.porEmpresa && p.porEmpresa.length > 1" style="padding:0 16px 12px;display:flex;gap:6px;flex-wrap:wrap;">
            <span v-for="pe in p.porEmpresa" :key="pe.empresa" style="font-size:10px;background:#f7f2ee;color:#655b63;padding:3px 9px;border-radius:8px;">{{ pe.empresa }}: R$ {{ fmtNum(pe.liquido) }}</span>
          </div>
          <div style="display:flex;justify-content:flex-end;gap:8px;padding:10px 16px;background:#fafbf8;border-top:1px solid #f2f3ef;">
            <select :value="p.status" @change="mudarStatusPagamento(p, $event.target.value)" style="margin:0;padding:6px 8px;font-size:11px;width:auto;">
              <option value="PENDENTE">Pendente</option>
              <option value="APROVADO">Aprovado</option>
              <option value="PAGO">Pago</option>
              <option value="CANCELADO">Cancelado</option>
            </select>
            <button @click="verDemonstrativo(p)" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:7px 14px;font-size:12px;background:#702e46;"><FileText :size="13" /> Recibo / PDF</button>
          </div>
        </div>
        </div>
      </div>
    </div>

    <Teleport to="body">
    <!-- Modal Fora da Condicao Comercial -->
    <Teleport to="body">
    <div v-if="modalForaCondicao.aberto" class="master-modal-overlay">
      <div class="master-modal" style="max-width:640px;">
        <h3>Fora da condição comercial — {{ modalForaCondicao.lote.arquivo }}</h3>
        <p style="font-size:12px;color:#888;margin:-8px 0 12px;">Essas linhas têm uma COMISSÃO % diferente das faixas combinadas (0,20% · 0,1143% · 0,10%). Foram descartadas da apuração automaticamente.</p>
        <div v-for="l in modalForaCondicao.linhas" :key="l.id" style="border:1px solid #eee;border-radius:8px;padding:10px 12px;margin-bottom:8px;font-size:12px;">
          <strong>{{ l.nome_consorciado }}</strong> · Contrato {{ l.contrato }} · Parcela {{ l.parcela }}
          <div style="color:#c0392b;font-weight:700;margin-top:3px;">Comissão informada: {{ l.comissao_pct }}</div>
          <div style="color:#888;margin-top:2px;">R$ {{ fmtNum(l.liquido_rs) }} · {{ l.entidade_nome || 'sem entidade' }}</div>
        </div>
        <div v-if="modalForaCondicao.linhas.length === 0" style="color:#aaa;text-align:center;padding:20px;">Nenhuma linha fora da condição comercial.</div>
        <div class="master-modal-acoes"><button @click="modalForaCondicao.aberto = false" style="background:#888;">Fechar</button></div>
      </div>
    </div>
    </Teleport>

    <!-- Modal Config Master -->
    <div v-if="modalConfigMaster" class="master-modal-overlay">
      <div class="master-modal">
        <h3>Configurações</h3>
        <div class="master-modal-acoes" style="flex-direction:column;">
          <button v-if="masterSelecionado" @click="modalConfigMaster = false; abrirModalMaster(masterAtual.id)">Editar Master</button>
        </div>
        <div class="master-modal-acoes">
          <button @click="modalConfigMaster = false" style="background:#888;">Fechar</button>
        </div>
      </div>
    </div>

    <!-- Modal Inconsistencias -->
    <div v-if="modalInconsist.aberto" class="master-modal-overlay">
      <div class="master-modal" style="max-width:640px;">
        <h3>Pendências — {{ modalInconsist.lote.arquivo }}</h3>
        <p style="font-size:12px;color:#888;margin:-8px 0 12px;">Agrupado por código Embracon. Escolha a entidade e resolve todas as linhas daquele código de uma vez — a próxima importação já reconhece sozinha.</p>
        <div v-for="g in pendenciasAgrupadas" :key="g.chave" style="border:1px solid #eee;border-radius:8px;padding:10px 12px;margin-bottom:8px;">
          <div style="font-size:12px;margin-bottom:6px;">
            <strong v-if="g.tipo">{{ g.rotulo }}: {{ g.codigo }}</strong>
            <strong v-else style="color:#c0392b;">Sem código identificável</strong>
            <span style="color:#888;"> · {{ g.linhas.length }} linha(s) · R$ {{ fmtNum(g.total) }}</span>
            <div style="color:#888;margin-top:2px;font-size:11px;">Ex: {{ g.linhas[0].nome_consorciado }} · Contrato {{ g.linhas[0].contrato }}</div>
          </div>
          <div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center;">
            <select v-model.number="g.entidadeId" style="flex:1;min-width:150px;margin:0;">
              <option :value="null">Selecione a entidade...</option>
              <option v-for="e in entidades" :key="e.id" :value="e.id">{{ e.nome_fantasia }}</option>
            </select>
            <button :disabled="!g.entidadeId" @click="resolverGrupo(g)" style="margin:0;padding:8px 14px;font-size:12px;">Resolver {{ g.linhas.length }} linha(s)</button>
          </div>
        </div>
        <div v-if="modalInconsist.linhas.length === 0" style="text-align:center;color:#27ae60;padding:20px;">Tudo resolvido!</div>
        <div class="master-modal-acoes"><button @click="fecharInconsistenciasEAtualizar" style="background:#888;">Fechar</button></div>
      </div>
    </div>

    <!-- Modal Apuracao -->
    <div v-if="modalApuracao.aberto" class="master-modal-overlay">
      <div class="master-modal" style="max-width:680px;">
        <h3>Apuração — {{ modalApuracao.lote.arquivo }}</h3>
        <div v-if="modalApuracao.linhasSemRegra > 0" class="nota-aviso">{{ modalApuracao.linhasSemRegra }} linha(s) identificada(s) mas sem regra de comissão vigente aplicável — não entraram na distribuição.</div>

        <div style="font-size:11px;font-weight:800;color:#702e46;text-transform:uppercase;margin:14px 0 8px;">Resumo por beneficiário</div>
        <div v-for="r in modalApuracao.resumo" :key="r.beneficiarioId" style="padding:7px 10px;background:#f7f2ee;border-radius:8px;margin-bottom:5px;font-size:13px;">
          <div style="display:flex;justify-content:space-between;">
            <span><strong>{{ r.beneficiarioNome }}</strong> <span style="color:#888;">({{ r.qtd }} itens)</span></span>
            <strong style="color:#702e46;">R$ {{ fmtNum(r.totalLiquido) }}</strong>
          </div>
          <div style="font-size:11px;color:#888;margin-top:2px;">Bruto: R$ {{ fmtNum(r.total) }}<span v-if="r.total !== r.totalLiquido"> · Imposto descontado: R$ {{ fmtNum(r.total - r.totalLiquido) }}</span></div>
        </div>
        <div style="display:flex;justify-content:space-between;padding:9px 10px;background:#702e46;color:white;border-radius:8px;margin:8px 0 14px;font-size:13px;">
          <strong>TOTAL LÍQUIDO</strong><strong>R$ {{ fmtNum(modalApuracao.valorTotalLiquido) }}</strong>
        </div>

        <details>
          <summary style="cursor:pointer;font-size:12px;color:#2980b9;font-weight:700;">Ver memória de cálculo completa ({{ modalApuracao.itens.length }} itens)</summary>
          <div style="max-height:260px;overflow-y:auto;margin-top:10px;">
            <div v-for="it in modalApuracao.itens" :key="it.id" style="border-bottom:1px solid #eee;padding:7px 0;font-size:11px;">
              <strong>{{ it.beneficiario_nome }}</strong> recebeu R$ {{ fmtNum(it.valor_liquido) }} líquido ({{ it.percentual }}% de R$ {{ fmtNum(it.base_utilizada) }}, bruto R$ {{ fmtNum(it.valor) }}<span v-if="it.imposto_pct > 0"> − {{ it.imposto_pct }}% imposto</span>)
              <div style="color:#888;">Origem: {{ it.origem_nome }} · Contrato {{ it.contrato }} · {{ it.nome_consorciado }} · Parcela {{ it.parcela }}</div>
            </div>
          </div>
        </details>

        <div class="master-modal-acoes">
          <button @click="gerarPagamentos" style="background:#27ae60;">Gerar Pagamentos</button>
          <button @click="reprocessarApuracao" style="background:#e67e22;">Reprocessar</button>
          <button @click="modalApuracao.aberto = false" style="background:#888;">Fechar</button>
        </div>
      </div>
    </div>

    <!-- Modal Master -->
    <div v-if="modalMaster.aberto" class="master-modal-overlay">
      <div class="master-modal">
        <h3>{{ modalMaster.id === -1 ? 'Novo Master' : 'Editar Master' }}</h3>
        <label>NOME</label><input type="text" v-model="modalMaster.form.nome" placeholder="Nome do Master" />
        <label>STATUS</label>
        <select v-model="modalMaster.form.status"><option value="ativo">Ativo</option><option value="inativo">Inativo</option></select>
        <label>OBSERVAÇÕES</label><textarea v-model="modalMaster.form.observacoes" style="width:100%;height:60px;"></textarea>

        <div class="master-modal-acoes">
          <button @click="modalMaster.aberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarMaster">Salvar</button>
        </div>
      </div>
    </div>

    <!-- Modal CNPJ -->
    <div v-if="modalCnpj.aberto" class="master-modal-overlay">
      <div class="master-modal">
        <h3>{{ modalCnpj.id === -1 ? 'Novo CNPJ' : 'Editar CNPJ' }}</h3>
        <label>CNPJ</label><input type="text" v-model="modalCnpj.form.cnpj" placeholder="00.000.000/0000-00" />
        <label>NOME / IDENTIFICAÇÃO</label><input type="text" v-model="modalCnpj.form.nome" placeholder="Ex: Matriz SP" />
        <label>STATUS</label>
        <select v-model="modalCnpj.form.status"><option value="ativo">Ativo</option><option value="inativo">Inativo</option></select>
        <label>RESERVA DE MARKETING (%)</label>
        <input type="number" step="0.01" min="0" v-model="modalCnpj.form.reserva_mkt_pct" placeholder="Ex: 2" />
        <div style="font-size:11px;color:#655b63;margin-top:-6px;">Percentual deduzido do topo da hierarquia na apuração, antes da distribuição das comissões.</div>
        <div class="master-modal-acoes">
          <button @click="modalCnpj.aberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarCnpj">Salvar</button>
        </div>
        <div v-if="modalCnpj.id !== -1" class="master-modal-acoes">
          <button @click="excluirCnpjNoModal" style="background:#c0392b;">Excluir CNPJ</button>
        </div>
      </div>
    </div>

    <!-- Drawer Entidade (unificado: dados + codigos + comissoes) -->
    <div v-if="modalEntidade.aberto" class="master-modal-overlay">
      <div class="master-modal">
        <h3>{{ modalEntidade.id === -1 ? 'Nova Entidade' : modalEntidade.form.nomeFantasia }}</h3>

        <div v-if="modalEntidade.id !== -1" class="master-modal-tabs">
          <div class="master-modal-tab" :class="{ ativa: modalEntidade.aba === 'dados' }" @click="modalEntidade.aba = 'dados'">Dados</div>
          <div class="master-modal-tab" :class="{ ativa: modalEntidade.aba === 'codigos' }" @click="modalEntidade.aba = 'codigos'">Códigos Embracon</div>
          <div class="master-modal-tab" :class="{ ativa: modalEntidade.aba === 'comissoes' }" @click="modalEntidade.aba = 'comissoes'">Comissões</div>
          <div class="master-modal-tab" :class="{ ativa: modalEntidade.aba === 'beneficiarios' }" @click="modalEntidade.aba = 'beneficiarios'">Beneficiários</div>
        </div>

        <!-- Aba Dados -->
        <div v-if="modalEntidade.aba === 'dados'">
          <label>LOGO DA EMPRESA</label>
          <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">
            <img v-if="modalEntidade.form.logoUrl" :src="modalEntidade.form.logoUrl" style="width:52px;height:52px;object-fit:contain;background:#f7f2ee;border-radius:8px;padding:4px;" />
            <div v-else style="width:52px;height:52px;border-radius:8px;background:#f7f2ee;display:flex;align-items:center;justify-content:center;color:#ccc;font-size:10px;">sem logo</div>
            <input type="file" accept="image/*" @change="selecionarLogoEntidade" style="flex:1;" />
          </div>
          <label>NOME FANTASIA</label><input type="text" v-model="modalEntidade.form.nomeFantasia" placeholder="Nome da empresa" />
          <label>RAZÃO SOCIAL</label><input type="text" v-model="modalEntidade.form.razaoSocial" />
          <label>CNPJ DA ENTIDADE</label><input type="text" v-model="modalEntidade.form.cnpj" />
          <label>CNPJ DO MASTER</label>
          <select v-model.number="modalEntidade.form.masterCnpjId">
            <option :value="null">Não vinculado</option>
            <option v-for="c in cnpjs" :key="c.id" :value="c.id">{{ c.nome }}</option>
          </select>
          <label>TIPO</label>
          <select v-model="modalEntidade.form.tipo">
            <option>Parceiro</option><option>Sub-Master</option><option>Cooperativa</option>
            <option>Empresa</option><option>Beneficiário</option><option>Outro</option>
          </select>
          <label>STATUS</label>
          <select v-model="modalEntidade.form.status"><option value="ativo">Ativo</option><option value="inativo">Inativo</option></select>
          <label>OBSERVAÇÕES</label><textarea v-model="modalEntidade.form.observacoes" style="width:100%;height:50px;"></textarea>
        </div>

        <!-- Aba Códigos Embracon -->
        <div v-if="modalEntidade.aba === 'codigos'">
          <div v-for="i in modalIdent.lista" :key="i.id" class="master-item-card">
            <div>
              <span class="master-item-tipo">{{ i.tipo_identificador }}</span>
              <div class="master-item-titulo" style="margin-top:4px;">{{ i.codigo }}</div>
            </div>
            <button @click="excluirIdentificador(i)" class="master-item-acao master-item-acao-danger">Excluir</button>
          </div>
          <div v-if="modalIdent.lista.length === 0" class="master-item-vazio">Nenhum código cadastrado ainda.</div>

          <div style="display:flex;gap:8px;margin-top:14px;flex-wrap:wrap;align-items:center;">
            <select v-model.number="presetSelecionado" style="flex:1;min-width:160px;margin:0;">
              <option :value="null">Grupo padrão...</option>
              <option v-for="p in presets" :key="p.id" :value="p.id">{{ p.nome }} ({{ p.itens.length }})</option>
            </select>
            <button @click="aplicarPreset" :disabled="!presetSelecionado" style="margin:0;padding:6px 10px;font-size:12px;">Aplicar</button>
            <button v-if="presetSelecionado" @click="excluirPresetSelecionado" style="margin:0;padding:6px 10px;font-size:12px;background:#c0392b;">Excluir grupo</button>
            <button @click="salvarPresetAtual" style="margin:0;padding:6px 10px;font-size:12px;background:#eee;color:#555;">Salvar estes como grupo</button>
          </div>

          <div style="display:flex;gap:8px;margin-top:14px;flex-wrap:wrap;">
            <select v-model="novoIdent.tipo" style="flex:1;min-width:140px;margin:0;">
              <option value="COD_COMISSIONADO">CÓD COMISSIONADO</option>
              <option value="COD_EQUIPE">CÓD EQUIPE</option>
              <option value="COD_PV">CÓD PV</option>
              <option value="COD_PONTO_VENDA">CÓD PONTO DE VENDA</option>
              <option value="COD_FILIAL">CÓD FILIAL</option>
              <option value="CATEGORIA">CATEGORIA</option>
              <option value="VENDEDOR">VENDEDOR</option>
              <option value="OUTRO">OUTRO</option>
            </select>
            <input type="text" v-model="novoIdent.codigo" placeholder="Código" style="flex:1;min-width:100px;margin:0;" />
            <button @click="salvarIdentificador" style="margin:0;">+ Add</button>
          </div>
          <div v-if="novoIdentContagem !== null" style="font-size:11px;color:#655b63;margin-top:4px;">
            {{ novoIdentContagem }} linha(s) do mapa atual ({{ loteAtualMapa.arquivo || 'nenhum selecionado' }}) batem com esse código.
          </div>
        </div>

        <!-- Aba Comissões -->
        <div v-if="modalEntidade.aba === 'comissoes'">
          <p class="master-aba-intro">Relacionamentos da estrutura em que essa empresa participa, e quem recebe comissão em cada um.</p>
          <div v-for="r in relacionamentosDaEntidadeAtual" :key="r.id" class="master-item-card master-item-card-col">
            <div class="master-item-titulo">{{ r.superiorNome }} → {{ r.subordinadaNome }}</div>
            <div class="master-item-sub">{{ (regrasAtuaisPorRelac[r.id] || []).map(p => p.nome + ' ' + p.percentual + '%').join(' / ') || 'Nenhuma regra vigente' }}</div>
            <button @click="abrirModalRegras(r)" class="master-item-acao" style="align-self:flex-start;margin-top:8px;">Configurar</button>
          </div>
          <div v-if="relacionamentosDaEntidadeAtual.length === 0" class="master-item-vazio">Essa empresa ainda não tem relacionamento cadastrado na estrutura.</div>
        </div>

        <!-- Aba Beneficiários -->
        <div v-if="modalEntidade.aba === 'beneficiarios'">
          <p class="master-aba-intro">Pessoas que recebem comissão nas regras vigentes dessa empresa.</p>
          <div v-for="b in beneficiariosDaEntidadeAtual" :key="b.nome" class="master-item-card">
            <div>
              <div class="master-item-titulo">{{ b.nome }}</div>
              <div class="master-item-sub">{{ b.relacionamentos.map(x => x.rotulo + ': ' + x.percentual + '%').join(' / ') }}</div>
            </div>
            <button v-if="b.id" @click="abrirModalBeneficiario(b.id)" class="master-item-acao">Editar</button>
          </div>
          <div v-if="beneficiariosDaEntidadeAtual.length === 0" class="master-item-vazio">Nenhuma regra vigente ainda define beneficiários pra essa empresa.</div>
          <button @click="abrirModalBeneficiario(-1)" class="master-item-acao" style="margin-top:12px;">+ Novo Beneficiário</button>
          <p class="master-aba-intro" style="margin-top:12px;margin-bottom:0;">Pra vincular um beneficiário a essa empresa, cadastre-o aqui e depois adicione ele numa regra de comissão na aba Comissões.</p>
        </div>

        <div class="master-modal-acoes">
          <button @click="modalEntidade.aberto = false" style="background:#888;">{{ modalEntidade.aba === 'dados' ? 'Cancelar' : 'Fechar' }}</button>
          <button v-if="modalEntidade.aba === 'dados'" @click="salvarEntidade">Salvar</button>
        </div>
        <div v-if="modalEntidade.id !== -1 && modalEntidade.aba === 'dados'" class="master-modal-acoes">
          <button @click="excluirEntidadeNoModal" style="background:#c0392b;">Excluir empresa</button>
        </div>
      </div>
    </div>

    <!-- Modal Relacionamento -->
    <div v-if="modalRelacionamento.aberto" class="master-modal-overlay">
      <div class="master-modal">
        <h3>{{ modalRelacionamento.id === -1 ? 'Novo Relacionamento' : 'Editar Relacionamento' }}</h3>
        <label>ENTIDADE SUPERIOR <span style="font-weight:normal;color:#888;">(vazio = ligado direto ao Master)</span></label>
        <select v-model.number="modalRelacionamento.form.entidadeSuperiorId">
          <option :value="null">— Direto no Master —</option>
          <option v-for="e in entidades" :key="e.id" :value="e.id">{{ e.nome_fantasia }}</option>
        </select>
        <label>ENTIDADE SUBORDINADA *</label>
        <select v-model.number="modalRelacionamento.form.entidadeSubordinadaId">
          <option :value="null">Selecione...</option>
          <option v-for="e in entidades" :key="e.id" :value="e.id">{{ e.nome_fantasia }}</option>
        </select>
        <label>STATUS</label>
        <select v-model="modalRelacionamento.form.status"><option value="ativo">Ativo</option><option value="inativo">Inativo</option></select>
        <label>OBSERVAÇÕES</label><textarea v-model="modalRelacionamento.form.observacoes" style="width:100%;height:50px;"></textarea>
        <div class="master-modal-acoes">
          <button @click="modalRelacionamento.aberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarRelacionamento">Salvar</button>
        </div>
      </div>
    </div>

    <!-- Modal Regras -->
    <div v-if="modalRegras.aberto" class="master-modal-overlay">
      <div class="master-modal" style="max-width:560px;">
        <h3>Comissão — {{ modalRegras.relacionamento.nome_subordinada }}</h3>
        <p style="font-size:11px;color:#888;margin:-10px 0 14px;">Quem recebe e quanto, sobre o que essa empresa fatura.</p>

        <div v-if="!modalRegras.editando">
          <div v-if="modalRegras.lista.length === 0" style="color:#aaa;text-align:center;padding:20px;">Nenhuma comissão configurada ainda.</div>
          <div v-for="r in modalRegras.lista" :key="r.id" style="border:1px solid #eee;border-radius:8px;padding:10px 12px;margin-bottom:8px;">
            <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;">
              <div style="font-size:12px;">
                <div>
                  <span v-for="d in r.distribuicoes" :key="d.id" style="display:inline-block;background:#efe3e8;color:#702e46;padding:3px 9px;border-radius:8px;margin:2px 4px 0 0;font-size:12px;font-weight:700;">{{ d.beneficiario_nome }}: {{ d.percentual }}%</span>
                </div>
                <div style="color:#888;margin-top:6px;">Desde {{ fmtData(r.vigencia_inicio) }}<span v-if="r.vigencia_fim"> até {{ fmtData(r.vigencia_fim) }}</span>
                  <span :style="{marginLeft:'6px',fontSize:'10px',padding:'2px 7px',borderRadius:'8px',background:r.status==='ativo'?'#e8f5e9':'#f0f0f0',color:r.status==='ativo'?'#2e7d32':'#888'}">{{ r.status }}</span>
                  <span v-if="r.parcela_condicao" style="margin-left:6px;font-size:10px;padding:2px 7px;border-radius:8px;background:#fdf0e3;color:#b8641b;font-weight:700;">só parcela {{ r.parcela_condicao }}</span>
                  <span v-else style="margin-left:6px;font-size:10px;padding:2px 7px;border-radius:8px;background:#eef2e7;color:#702e46;">todas as parcelas</span>
                </div>
              </div>
              <div style="display:flex;gap:5px;flex-shrink:0;">
                <button @click="editarRegra(r)" style="margin:0;padding:5px 9px;font-size:11px;">Editar</button>
                <button v-if="r.status==='ativo'" @click="encerrarRegra(r)" style="margin:0;padding:5px 9px;font-size:11px;background:#e67e22;">Encerrar</button>
                <button @click="excluirRegra(r)" style="margin:0;padding:5px 9px;font-size:11px;background:#c0392b;">Excluir</button>
              </div>
            </div>
          </div>
          <button @click="novaRegra" style="margin-top:4px;padding:9px 16px;font-size:13px;width:100%;">+ Nova divisão de comissão</button>
          <div class="master-modal-acoes"><button @click="modalRegras.aberto = false" style="background:#888;">Fechar</button></div>
        </div>

        <div v-else>
          <div style="background:#f7f2ee;border-radius:8px;padding:10px;">
            <div style="font-size:11px;font-weight:800;color:#702e46;text-transform:uppercase;margin-bottom:8px;">Quem recebe e quanto</div>
            <div v-for="(d, i) in formRegra.distribuicoes" :key="i" style="margin-bottom:6px;">
              <div v-if="d._confirmado" style="display:flex;align-items:center;justify-content:space-between;gap:6px;background:#eef2e7;border-radius:8px;padding:8px 10px;">
                <span style="font-size:13px;"><strong>{{ nomeBeneficiario(d.beneficiarioId) }}</strong> — {{ d.percentual }}%</span>
                <div style="display:flex;gap:6px;flex-shrink:0;">
                  <button @click="d._confirmado = false" style="margin:0;padding:5px 9px;font-size:11px;background:#eee;color:#555;">Editar</button>
                  <button @click="formRegra.distribuicoes.splice(i,1)" style="margin:0;padding:5px 9px;font-size:11px;background:#c0392b;">✕</button>
                </div>
              </div>
              <div v-else style="display:flex;gap:6px;">
                <select v-model.number="d.beneficiarioId" style="flex:1;margin:0;">
                  <option :value="null">Selecione a pessoa...</option>
                  <option v-for="b in beneficiarios" :key="b.id" :value="b.id">{{ b.nome }}</option>
                </select>
                <input type="number" v-model.number="d.percentual" placeholder="%" style="width:80px;margin:0;" />
                <button @click="confirmarDistribuicao(i)" style="margin:0;padding:8px 12px;font-size:12px;">Adicionar</button>
                <button v-if="formRegra.distribuicoes.length > 1" @click="formRegra.distribuicoes.splice(i,1)" style="margin:0;padding:8px 10px;background:#c0392b;">✕</button>
              </div>
            </div>
            <div style="display:flex;gap:6px;margin-top:4px;">
              <button v-if="!formRegra.distribuicoes.some(d => !d._confirmado)" @click="formRegra.distribuicoes.push({beneficiarioId:null,percentual:0,_confirmado:false})" style="padding:7px 12px;font-size:12px;background:#888;">+ Pessoa</button>
              <button @click="abrirModalBeneficiario(-1)" style="padding:7px 12px;font-size:12px;background:#eee;color:#555;">+ Pessoa nova</button>
            </div>
            <div style="margin-top:8px;font-size:12px;font-weight:700;" :style="{color: Math.abs(somaDistribuicao-100)<0.01 ? '#27ae60' : '#c0392b'}">Soma: {{ somaDistribuicao.toFixed(2) }}%</div>
          </div>

          <div style="background:#f7f2ee;border-radius:8px;padding:10px;margin-top:12px;">
            <div style="font-size:11px;font-weight:800;color:#702e46;text-transform:uppercase;margin-bottom:8px;">Essa distribuição vale sobre</div>
            <label style="display:flex;align-items:center;gap:6px;font-weight:normal;">
              <input type="radio" value="" v-model="formRegra.parcelaCondicao" style="width:auto;margin:0;" />
              <span style="text-transform:none;">Todas as parcelas</span>
            </label>
            <label style="display:flex;align-items:center;gap:6px;font-weight:normal;margin-top:6px;">
              <input type="radio" value="1" v-model="formRegra.parcelaCondicao" style="width:auto;margin:0;" />
              <span style="text-transform:none;">Só uma parcela específica</span>
            </label>
            <div v-if="formRegra.parcelaCondicao !== ''" style="margin-top:8px;margin-left:24px;">
              <label>QUAL PARCELA?</label>
              <input type="text" v-model="formRegra.parcelaCondicao" placeholder="Ex: 1 (a primeira)" style="max-width:160px;" />
            </div>
            <div style="font-size:11px;color:#888;margin-top:8px;line-height:1.5;">
              Dá para combinar: uma regra "todas as parcelas" com os % de sempre, + outra regra só na 1ª parcela com um bônus extra pra alguém específico (ex: Dovale). As duas ficam ativas ao mesmo tempo, cada uma vale só sobre a condição dela.
            </div>
          </div>

          <div style="margin-top:12px;">
            <button @click="formRegra._avancado = !formRegra._avancado" style="padding:6px 10px;font-size:11px;background:transparent;color:#888;border:1px solid #ddd;">{{ formRegra._avancado ? 'Esconder opções avançadas ▲' : 'Opções avançadas ▼' }}</button>
          </div>

          <div v-if="formRegra._avancado" style="margin-top:10px;">
            <label>BASE DE CÁLCULO</label>
            <select v-model="formRegra.baseCalculo">
              <option value="liquido">Comissão líquida</option>
              <option value="bruto">Comissão bruta</option>
              <option value="base_embracon">Base de cálculo Embracon</option>
            </select>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
              <div><label>VIGÊNCIA INÍCIO *</label><input type="date" v-model="formRegra.vigenciaInicio" /></div>
              <div><label>VIGÊNCIA FIM <span style="font-weight:normal;color:#888;">(vazio = aberto)</span></label><input type="date" v-model="formRegra.vigenciaFim" /></div>
            </div>
            <div><label>CONDIÇÃO DE CATEGORIA</label><input type="text" v-model="formRegra.categoriaCondicao" placeholder="Opcional" /></div>
            <label style="display:flex;align-items:center;gap:6px;margin-top:10px;">
              <input type="checkbox" v-model="formRegra.exigeSoma100" style="width:auto;margin:0;" />
              <span style="text-transform:none;font-weight:normal;">Exigir que a distribuição some exatamente 100%</span>
            </label>
          </div>

          <div class="master-modal-acoes">
            <button @click="modalRegras.editando = false" style="background:#888;">Voltar</button>
            <button @click="salvarRegra">Salvar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Beneficiario -->
    <div v-if="modalBeneficiario.aberto" class="master-modal-overlay">
      <div class="master-modal">
        <h3>{{ modalBeneficiario.id === -1 ? 'Novo Beneficiário' : 'Editar Beneficiário' }}</h3>
        <label>NOME</label><input type="text" v-model="modalBeneficiario.form.nome" />
        <label>TIPO</label>
        <select v-model="modalBeneficiario.form.tipo">
          <option>Master</option><option>Sub-Master</option><option>Parceiro</option>
          <option>Beneficiário</option><option>Apoio</option><option>Consultor</option>
          <option>Empresa</option><option>Outro</option>
        </select>
        <label>CPF/CNPJ</label><input type="text" v-model="modalBeneficiario.form.cpfCnpj" />
        <label>CHAVE PIX</label><input type="text" v-model="modalBeneficiario.form.pixChave" />
        <label>% IMPOSTO <span style="font-weight:normal;color:#888;">(descontado do valor bruto na apuração)</span></label>
        <input type="number" step="0.01" v-model.number="modalBeneficiario.form.impostoPct" placeholder="Ex: 16" />
        <label>STATUS</label>
        <select v-model="modalBeneficiario.form.status"><option value="ativo">Ativo</option><option value="inativo">Inativo</option></select>
        <div class="master-modal-acoes">
          <button @click="modalBeneficiario.aberto = false" style="background:#888;">Cancelar</button>
          <button @click="salvarBeneficiario">Salvar</button>
        </div>
      </div>
    </div>
    </Teleport>
  </div>
</template>

<style scoped>
/* Drawer: ancorado na direita, ~40% da largura da tela */
.master-modal-overlay{display:flex;position:fixed;inset:0;background:rgba(48,35,48,.45);z-index:9999;justify-content:flex-end;align-items:stretch;padding:0;overflow:hidden;}
.master-modal{background:white;border-radius:0;padding:24px;width:40vw;min-width:420px;max-width:640px;height:100%;max-height:100%;overflow-y:auto;box-shadow:-10px 0 32px rgba(48,35,48,.18);display:flex;flex-direction:column;animation:master-drawer-in .22s cubic-bezier(.3,.9,.3,1);}
@keyframes master-drawer-in{from{transform:translateX(100%)}to{transform:translateX(0)}}
.master-modal-tabs{display:flex;gap:2px;margin:-24px -24px 16px;padding:0 24px;border-bottom:1px solid var(--line);}
.master-modal-tab{padding:12px 4px;margin-right:18px;font-size:12px;font-weight:700;color:#655b63;border-bottom:2px solid transparent;cursor:pointer;}
.master-modal-tab.ativa{color:#702e46;border-bottom-color:#702e46;}
.master-aba-intro{font-size:12px;color:#655b63;margin:0 0 14px;line-height:1.5;}
.master-item-card{display:flex;justify-content:space-between;align-items:center;gap:10px;border:1px solid var(--line);border-radius:10px;padding:12px 14px;margin-bottom:8px;background:#fff;transition:border-color .15s,box-shadow .15s;}
.master-item-card:hover{border-color:#cbb9c4;box-shadow:var(--shadow-sm);}
.master-item-card-col{flex-direction:column;align-items:flex-start;}
.master-item-titulo{font-size:13px;font-weight:700;color:#302330;}
.master-item-sub{font-size:11px;color:#655b63;margin-top:3px;line-height:1.5;}
.master-item-tipo{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#702e46;background:#efe3e8;padding:3px 8px;border-radius:6px;}
.master-item-acao{flex-shrink:0;margin:0;padding:7px 13px;font-size:11px;font-weight:700;background:#f7f2ee;color:#702e46;border-radius:8px;}
.master-item-acao:hover{background:#efe3e8;}
.master-item-acao-danger{background:#fbe9e7;color:#b42318;}
.master-item-acao-danger:hover{background:#f6d4d0;}
.master-item-vazio{color:#a79aa5;text-align:center;padding:24px 12px;font-size:12px;}
.master-modal h3{color:#702e46;margin-bottom:16px;font-family:'Manrope',Inter,Arial,sans-serif;}
.master-modal label{display:block;margin-top:10px;font-size:11px;font-weight:bold;color:#555;text-transform:uppercase;}
.master-modal-acoes{display:flex;gap:10px;margin:auto -24px -24px;padding:14px 24px 24px;border-top:1px solid var(--line);position:sticky;bottom:-24px;background:white;}
@media(max-width:900px){.master-modal{width:100%;min-width:0;max-width:100%}}
.master-modal-acoes button{flex:1;margin:0;}
.nota-aviso{background:#fff8e1;color:#8a6d1d;border-radius:8px;padding:8px 12px;font-size:12px;margin-top:10px;}
.org-wrap{position:relative;min-width:100%;width:max-content;padding:10px;}
.org-svg{position:absolute;top:0;left:0;pointer-events:none;}
.org-item{display:flex;flex-direction:column;align-items:center;position:relative;z-index:1;}
.org-filhos{display:flex;gap:28px;padding-top:34px;}
.org-box{background:#fff;border:1px solid #ded6dc;border-radius:6px;padding:10px 14px;min-width:150px;text-align:center;}
.org-box-master{background:#302330;border-color:#302330;}
.org-box-master .org-nome{color:#fff;}
.org-box-master .org-tipo{color:#e3d3da;}
.org-nome{font-size:13px;font-weight:700;color:#302330;}
.org-tipo{font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#655b63;margin-top:2px;}
.arvore-master{display:flex;align-items:baseline;gap:10px;padding-bottom:12px;border-bottom:1px solid #e8e8e2;margin-bottom:4px;}
.arvore-master-nome{font-size:16px;font-weight:800;color:#302330;}
.arvore-master-label{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#655b63;background:#efe3e8;padding:3px 9px;border-radius:4px;}
.arvore-lista{padding-top:6px;}
.arvore-linha{position:relative;display:flex;align-items:center;gap:8px;padding:9px 0;border-bottom:1px solid #f2f3ef;}
.arvore-linha:last-child{border-bottom:none;}
.arvore-conector{position:absolute;top:0;bottom:50%;width:14px;border-left:1px solid #ded6dc;border-bottom:1px solid #ded6dc;border-bottom-left-radius:6px;}
.arvore-nome{font-size:13px;font-weight:600;color:#302330;}
.arvore-tipo{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.03em;color:#655b63;background:#efe3e8;padding:2px 8px;border-radius:4px;}
.arvore-vazio{color:#655b63;padding:16px 0;font-size:13px;}
.arvore-orfas{margin-top:18px;border-top:1px solid #eee;padding-top:12px;}
.arvore-orfas-titulo{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#655b63;margin-bottom:8px;}
.arvore-orfa-item{font-size:12px;color:#655b63;padding:4px 0;}
.master-cabecalho{display:flex;gap:8px;align-items:center;justify-content:space-between;margin-bottom:16px;}
.master-cabecalho-nome{font-size:18px;font-weight:800;color:#302330;}
.master-select-compacto{flex:1;margin:0;padding:10px 12px;font-size:13px;}
.master-config-btn{display:inline-flex;align-items:center;justify-content:center;margin:0;width:40px;height:40px;flex-shrink:0;padding:0;background:#e8e8e2;color:#555;}
.visao-geral-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px;}
.est-cnpjs{margin-bottom:14px;}
.est-cnpjs-titulo{font-size:11px;font-weight:800;color:#888;text-transform:uppercase;display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;}
.est-link-btn{margin:0;padding:3px 9px;font-size:11px;background:#efe3e8;color:#702e46;}
.est-cnpjs-lista{display:flex;flex-wrap:wrap;gap:6px;}
.est-cnpj-chip{font-size:12px;font-weight:600;color:#702e46;background:#efe3e8;padding:5px 10px;border-radius:14px;cursor:pointer;}
.est-arvore{margin-top:4px;}
</style>

<script>
import { apiGet, apiPost, apiDelete, apiPublicGet } from '../api'
import MasterOrganogramaNo from '../components/MasterOrganogramaNo.vue'
import MasterEstruturaNo from '../components/MasterEstruturaNo.vue'
import { Settings, ChevronDown, ChevronRight, TriangleAlert, FileText } from 'lucide-vue-next'

export default {
  name: 'PaginaMaster',
  components: { MasterOrganogramaNo, MasterEstruturaNo, Settings, ChevronDown, ChevronRight, TriangleAlert, FileText },
  data() {
    return {
      masters: [],
      masterSelecionado: null,
      aba: 'visaoGeral',
      cadastrosSubAba: 'cnpjs',
      buscaEmpresas: '',
      mapaSelecionado: null,
      mapaLinhas: [],
      mapaEmpresaDetalhe: null,
      buscaMapaEmpresa: '',
      buscaContratoMapa: '',
      mapaVincularSelecao: {},
      mapaDrillVista: 'contratos',
      mapaVista: 'contratos',
      mapaBusca: '',
      mapaFiltroEmpresaNome: '',
      mapaFiltroSituacao: '',
      mapaFiltroParcela: '',
      mapaFiltroIdentificacao: 'identificadas',
      mapaIncluirNaoIdentificadasNaSoma: false,
      mapaOrdenarCampo: 'liquido',
      mapaOrdenarDir: 'desc',
      mapaPaginaAtual: 1,
      mapaLinhasPorPagina: 25,
      mapaLinhaExpandidaId: null,
      modalConfigMaster: false,
      estruturaVista: 'lista',
      regrasAtuaisPorRelac: {},
      identificadoresPorEntidade: {},
      orgLinhas: [],
      cnpjs: [],
      entidades: [],
      relacionamentos: [],
      beneficiarios: [],
      modalMaster: { aberto: false, id: -1, form: { nome: '', status: 'ativo', observacoes: '' } },
      modalCnpj: { aberto: false, id: -1, form: { cnpj: '', nome: '', status: 'ativo', reserva_mkt_pct: 0 } },
      modalEntidade: { aberto: false, id: -1, aba: 'dados', pendingSuperiorId: undefined, form: { nomeFantasia: '', razaoSocial: '', cnpj: '', masterCnpjId: null, tipo: 'Parceiro', status: 'ativo', observacoes: '' } },
      modalIdent: { aberto: false, entidade: {}, lista: [] },
      novoIdent: { tipo: 'COD_COMISSIONADO', codigo: '' },
      presets: [],
      presetSelecionado: null,
      modalRelacionamento: { aberto: false, id: -1, form: { entidadeSuperiorId: null, entidadeSubordinadaId: null, status: 'ativo', observacoes: '' } },
      modalBeneficiario: { aberto: false, id: -1, form: { nome: '', tipo: 'Parceiro', cpfCnpj: '', pixChave: '', status: 'ativo', impostoPct: 0 } },
      modalRegras: { aberto: false, editando: false, relacionamento: {}, lista: [] },
      formRegra: { id: -1, baseCalculo: 'liquido', vigenciaInicio: '', vigenciaFim: '', parcelaCondicao: '', categoriaCondicao: '', exigeSoma100: true, distribuicoes: [] },
      lotes: [],
      importForm: { masterCnpjId: null, competencia: '', nomeArquivo: '', dados: null },
      importando: false,
      importStatus: '',
      importStatusClasse: '',
      modalInconsist: { aberto: false, lote: {}, linhas: [] },
      apuracoes: [],
      modalApuracao: { aberto: false, lote: {}, apuracaoId: null, itens: [], resumo: [], valorTotal: 0, valorTotalLiquido: 0, linhasSemRegra: 0 },
      dashboard: { producaoTotal: 0, comissaoBruta: 0, estornos: 0, cancelamentos: 0, comissaoLiquida: 0, linhasPendentes: 0, totalApurado: 0, totalPago: 0, totalPendente: 0, qtdEntidades: 0, maioresProdutores: [] },
      pagamentos: [],
      pagamentosVista: 'cards',
      pagamentosFiltroMapa: null,
      menuRapido: { aberto: false, no: {} },
      modalForaCondicao: { aberto: false, lote: {}, linhas: [] }
    }
  },
  computed: {
    masterAtual() {
      return this.masters.find(m => m.id === this.masterSelecionado) || {}
    },
    somaDistribuicao() {
      return this.formRegra.distribuicoes.filter(d => d._confirmado).reduce((s, d) => s + (parseFloat(d.percentual) || 0), 0)
    },
    pendenciasEstruturais() {
      const semIdentificador = this.entidades.filter(e => !(this.identificadoresPorEntidade[e.id] || []).length)
      const semRegra = this.relacionamentos.filter(r => !(this.regrasAtuaisPorRelac[r.id] || []).length)
      const semImposto = this.beneficiarios.filter(b => b.imposto_pct === null || b.imposto_pct === undefined)
      return { semIdentificador, semRegra, semImposto, total: semIdentificador.length + semRegra.length }
    },
    loteAtualMapa() {
      return this.lotes.find(l => l.id === this.mapaSelecionado) || {}
    },
    lotesNaoApurados() {
      return this.lotes.filter(l => l.status !== 'APURADO')
    },
    novoIdentContagem() {
      const abaCodigosAberta = this.modalIdent.aberto || (this.modalEntidade.aberto && this.modalEntidade.aba === 'codigos')
      if (!abaCodigosAberta || !this.novoIdent.codigo) return null
      const campoPorTipo = { COD_COMISSIONADO: 'cod_comissionado', COD_EQUIPE: 'cod_equipe', COD_PV: 'cod_pv', COD_PONTO_VENDA: 'cod_ponto_venda', COD_FILIAL: 'codigo_filial', CATEGORIA: 'categoria', VENDEDOR: 'vendedor' }
      const campo = campoPorTipo[this.novoIdent.tipo]
      if (!campo) return null
      const codigo = this.novoIdent.codigo.toString().trim().toLowerCase()
      if (!codigo) return null
      return this.mapaLinhas.filter(l => (l[campo] || '').toString().trim().toLowerCase() === codigo).length
    },
    mapaTotais() {
      const liq = this.mapaLinhas.reduce((s, l) => s + (parseFloat(l.comissao_rs) - parseFloat(l.estorno_rs) - parseFloat(l.cancelamento_cota_rs)), 0)
      return { liquido: liq, registros: this.mapaLinhas.length }
    },
    mapaResumoPorEmpresa() {
      const prioridade = [
        ['COD_COMISSIONADO', 'cod_comissionado'],
        ['COD_EQUIPE', 'cod_equipe'],
        ['COD_PV', 'cod_pv'],
        ['COD_PONTO_VENDA', 'cod_ponto_venda'],
        ['COD_FILIAL', 'codigo_filial'],
        ['VENDEDOR', 'vendedor']
      ]
      const grupos = {}
      this.mapaLinhas.forEach(l => {
        let chave, nome, cadastrada, tipo = null, codigo = null
        if (l.entidade_id) {
          chave = 'e' + l.entidade_id
          nome = l.entidade_nome
          cadastrada = true
        } else {
          for (const [t, campo] of prioridade) {
            if (l[campo]) { tipo = t; codigo = l[campo]; break }
          }
          codigo = codigo || 'sem-codigo'
          chave = 'p' + tipo + ':' + codigo
          nome = 'Código ' + codigo + ' (não cadastrada)'
          cadastrada = false
        }
        if (!grupos[chave]) grupos[chave] = { chave, nome, cadastrada, tipo, codigo, registros: 0, comissao: 0, estorno: 0, cancelamento: 0, liquido: 0, linhas: [] }
        const g = grupos[chave]
        g.registros++
        g.comissao += parseFloat(l.comissao_rs) || 0
        g.estorno += parseFloat(l.estorno_rs) || 0
        g.cancelamento += parseFloat(l.cancelamento_cota_rs) || 0
        g.liquido += (parseFloat(l.comissao_rs) || 0) - (parseFloat(l.estorno_rs) || 0) - (parseFloat(l.cancelamento_cota_rs) || 0)
        g.linhas.push(l)
      })
      return Object.values(grupos).sort((a, b) => b.liquido - a.liquido)
    },
    mapaResumoPorEmpresaFiltrado() {
      const busca = (this.buscaMapaEmpresa || '').trim().toLowerCase()
      if (!busca) return this.mapaResumoPorEmpresa
      return this.mapaResumoPorEmpresa.filter(g => g.nome.toLowerCase().includes(busca))
    },
    contratosFiltradosMapa() {
      if (!this.mapaEmpresaDetalhe) return []
      const busca = (this.buscaContratoMapa || '').trim().toLowerCase()
      if (!busca) return this.mapaEmpresaDetalhe.linhas
      return this.mapaEmpresaDetalhe.linhas.filter(l =>
        (l.contrato || '').toLowerCase().includes(busca) ||
        (l.nome_consorciado || '').toLowerCase().includes(busca) ||
        (l.vendedor || '').toLowerCase().includes(busca)
      )
    },
    mapaLinhasParaSoma() {
      return this.mapaIncluirNaoIdentificadasNaSoma ? this.mapaLinhasFiltradas : this.mapaLinhasFiltradas.filter(l => l.entidade_id)
    },
    resumoPorVendedorMapa() {
      const grupos = {}
      this.mapaLinhasParaSoma.forEach(l => {
        const chave = l.vendedor || '(sem vendedor)'
        if (!grupos[chave]) grupos[chave] = { vendedor: chave, registros: 0, comissao: 0, estorno: 0, cancelamento: 0, liquido: 0 }
        const g = grupos[chave]
        g.registros++
        g.comissao += parseFloat(l.comissao_rs) || 0
        g.estorno += parseFloat(l.estorno_rs) || 0
        g.cancelamento += parseFloat(l.cancelamento_cota_rs) || 0
        g.liquido += l._liquido
      })
      return Object.values(grupos).sort((a, b) => b.liquido - a.liquido)
    },
    mapaLinhasEnriquecidas() {
      return this.mapaLinhas.map(l => {
        const comissao = parseFloat(l.comissao_rs) || 0
        const estorno = parseFloat(l.estorno_rs) || 0
        const cancelamento = parseFloat(l.cancelamento_cota_rs) || 0
        let situacao = 'recebida'
        if (cancelamento > 0) situacao = 'cancelado'
        else if (estorno > 0) situacao = 'estornado'
        const codigoEmbracon = l.codigo_filial || l.cod_comissionado || l.cod_equipe || l.cod_pv || l.cod_ponto_venda || ''
        const parcelaNum = (l.parcela || '').toString().match(/(\d+)/)
        return {
          ...l,
          _comissao: comissao,
          _estorno: estorno,
          _cancelamento: cancelamento,
          _liquido: comissao - estorno - cancelamento,
          _situacao: situacao,
          _empresaNome: l.entidade_id ? (l.entidade_nome || '—') : 'Não identificada',
          _codigoEmbracon: codigoEmbracon,
          _parcelaNum: parcelaNum ? parseInt(parcelaNum[1]) : null
        }
      })
    },
    mapaEmpresasDisponiveis() {
      const nomes = new Set()
      this.mapaLinhasEnriquecidas.forEach(l => { if (l.entidade_id) nomes.add(l._empresaNome) })
      return Array.from(nomes).sort()
    },
    mapaLinhasFiltradas() {
      const busca = (this.mapaBusca || '').trim().toLowerCase()
      return this.mapaLinhasEnriquecidas.filter(l => {
        if (this.mapaFiltroIdentificacao === 'identificadas' && !l.entidade_id) return false
        if (this.mapaFiltroIdentificacao === 'nao_identificadas' && l.entidade_id) return false
        if (this.mapaFiltroEmpresaNome && l._empresaNome !== this.mapaFiltroEmpresaNome) return false
        if (this.mapaFiltroSituacao && l._situacao !== this.mapaFiltroSituacao) return false
        if (this.mapaFiltroParcela === '1' && l._parcelaNum !== 1) return false
        if (this.mapaFiltroParcela === '2+' && (l._parcelaNum === null || l._parcelaNum < 2)) return false
        if (busca && !(
          (l.contrato || '').toLowerCase().includes(busca) ||
          (l.nome_consorciado || '').toLowerCase().includes(busca) ||
          (l.vendedor || '').toLowerCase().includes(busca) ||
          (l._codigoEmbracon || '').toString().toLowerCase().includes(busca)
        )) return false
        return true
      })
    },
    mapaTotaisFiltrados() {
      return this.mapaLinhasParaSoma.reduce((acc, l) => {
        acc.comissao += l._comissao
        acc.estorno += l._estorno
        acc.cancelamento += l._cancelamento
        acc.liquido += l._liquido
        return acc
      }, { comissao: 0, estorno: 0, cancelamento: 0, liquido: 0 })
    },
    mapaPendenciasCount() {
      return this.mapaLinhasEnriquecidas.filter(l => !l.entidade_id).length
    },
    mapaLinhasOrdenadas() {
      const campo = this.mapaOrdenarCampo
      const dir = this.mapaOrdenarDir === 'asc' ? 1 : -1
      const campoValor = (l) => {
        if (campo === 'empresa') return (l._empresaNome || '').toLowerCase()
        if (campo === 'liquido') return l._liquido
        if (campo === 'comissao') return l._comissao
        return l._liquido
      }
      return [...this.mapaLinhasFiltradas].sort((a, b) => {
        const va = campoValor(a), vb = campoValor(b)
        if (va < vb) return -1 * dir
        if (va > vb) return 1 * dir
        return 0
      })
    },
    mapaTotalPaginas() {
      return Math.max(1, Math.ceil(this.mapaLinhasOrdenadas.length / this.mapaLinhasPorPagina))
    },
    mapaLinhasPaginadas() {
      const inicio = (this.mapaPaginaAtual - 1) * this.mapaLinhasPorPagina
      return this.mapaLinhasOrdenadas.slice(inicio, inicio + this.mapaLinhasPorPagina)
    },
    entidadesFiltradas() {
      const busca = (this.buscaEmpresas || '').trim().toLowerCase()
      if (!busca) return this.entidades
      return this.entidades.filter(e => (e.nome_fantasia || '').toLowerCase().includes(busca))
    },
    entidadesAgrupadasPorCnpj() {
      const grupos = {}
      this.entidadesFiltradas.forEach(e => {
        const chave = e.master_cnpj_id || 'sem-cnpj'
        if (!grupos[chave]) grupos[chave] = { nome: e.master_cnpj_id ? this.cnpjNome(e.master_cnpj_id) : 'Sem CNPJ vinculado', entidades: [] }
        grupos[chave].entidades.push(e)
      })
      return Object.values(grupos).sort((a, b) => a.nome.localeCompare(b.nome))
    },
    relacionamentosDaEntidadeAtual() {
      if (this.modalEntidade.id === -1) return []
      return this.relacionamentosComNome.filter(r => r.entidade_superior_id === this.modalEntidade.id || r.entidade_subordinada_id === this.modalEntidade.id)
    },
    beneficiariosDaEntidadeAtual() {
      const porNome = {}
      this.relacionamentosDaEntidadeAtual.forEach(r => {
        (this.regrasAtuaisPorRelac[r.id] || []).forEach(p => {
          if (!porNome[p.nome]) {
            const b = this.beneficiarios.find(x => x.nome === p.nome)
            porNome[p.nome] = { nome: p.nome, id: b ? b.id : null, relacionamentos: [] }
          }
          porNome[p.nome].relacionamentos.push({ rotulo: r.superiorNome + ' → ' + r.subordinadaNome, percentual: p.percentual })
        })
      })
      return Object.values(porNome)
    },
    relacionamentosComNome() {
      const entidadePorId = {}
      this.entidades.forEach(e => { entidadePorId[e.id] = e })
      return this.relacionamentos.map(r => ({
        ...r,
        superiorNome: r.entidade_superior_id === null ? 'Master (direto)' : (entidadePorId[r.entidade_superior_id] ? entidadePorId[r.entidade_superior_id].nome_fantasia : '—'),
        subordinadaNome: entidadePorId[r.entidade_subordinada_id] ? entidadePorId[r.entidade_subordinada_id].nome_fantasia : '—'
      }))
    },
    arvoreNos() {
      const porSuperior = {}
      this.relacionamentos.forEach(r => {
        const chave = r.entidade_superior_id === null ? 'raiz' : r.entidade_superior_id
        if (!porSuperior[chave]) porSuperior[chave] = []
        porSuperior[chave].push(r.entidade_subordinada_id)
      })
      const entidadePorId = {}
      this.entidades.forEach(e => { entidadePorId[e.id] = e })
      const nos = []
      const visitados = new Set()
      function visitar(idsFilhos, nivel) {
        (idsFilhos || []).forEach(id => {
          if (visitados.has(id)) return
          visitados.add(id)
          const ent = entidadePorId[id]
          if (!ent) return
          nos.push({ entidade: ent, nivel })
          visitar(porSuperior[id], nivel + 1)
        })
      }
      visitar(porSuperior['raiz'], 0)
      return nos
    },
    entidadesOrfas() {
      const comRelacionamento = new Set(this.relacionamentos.map(r => r.entidade_subordinada_id))
      return this.entidades.filter(e => !comRelacionamento.has(e.id))
    },
    organogramaArvore() {
      const entidadePorId = {}
      this.entidades.forEach(e => { entidadePorId[e.id] = e })
      const filhosPorSuperior = {}
      this.relacionamentos.forEach(r => {
        const chave = r.entidade_superior_id === null ? 'raiz' : r.entidade_superior_id
        if (!filhosPorSuperior[chave]) filhosPorSuperior[chave] = []
        filhosPorSuperior[chave].push(r)
      })
      const montarBeneficiarios = (relacionamentoId) => {
        return (this.regrasAtuaisPorRelac[relacionamentoId] || []).map((p, i) => ({
          id: 'benef-' + relacionamentoId + '-' + i,
          tipo: 'beneficiario',
          nome: p.nome,
          percentualEdge: p.percentual,
          filhos: []
        }))
      }
      const montarEntidade = (relacionamento) => {
        const ent = entidadePorId[relacionamento.entidade_subordinada_id]
        if (!ent) return null
        const filhosEntidades = (filhosPorSuperior[ent.id] || []).map(montarEntidade).filter(Boolean)
        const filhosBenef = montarBeneficiarios(relacionamento.id)
        return {
          id: ent.id,
          tipo: 'entidade',
          nome: ent.nome_fantasia,
          tipoEntidade: ent.tipo,
          relacionamentoId: relacionamento.id,
          filhos: [...filhosEntidades, ...filhosBenef]
        }
      }
      const raizRelacionamentos = filhosPorSuperior['raiz'] || []
      const porCnpj = {}
      raizRelacionamentos.forEach(r => {
        const ent = entidadePorId[r.entidade_subordinada_id]
        const chave = (ent && ent.master_cnpj_id) ? ent.master_cnpj_id : 'sem-cnpj'
        if (!porCnpj[chave]) porCnpj[chave] = []
        porCnpj[chave].push(r)
      })
      const nos = []
      this.cnpjs.forEach(c => {
        const rels = porCnpj[c.id]
        if (rels && rels.length) {
          nos.push({ id: 'cnpj-' + c.id, tipo: 'cnpj', nome: c.nome, filhos: rels.map(montarEntidade).filter(Boolean) })
        }
      })
      if (porCnpj['sem-cnpj'] && porCnpj['sem-cnpj'].length) {
        nos.push({ id: 'cnpj-sem', tipo: 'cnpj', nome: 'Sem CNPJ definido', filhos: porCnpj['sem-cnpj'].map(montarEntidade).filter(Boolean) })
      }
      return nos
    },
    estruturaArvore() {
      const entidadePorId = {}
      this.entidades.forEach(e => { entidadePorId[e.id] = e })
      const filhosPorSuperior = {}
      this.relacionamentos.forEach(r => {
        const chave = r.entidade_superior_id === null ? 'raiz' : r.entidade_superior_id
        if (!filhosPorSuperior[chave]) filhosPorSuperior[chave] = []
        filhosPorSuperior[chave].push(r)
      })
      const montar = (relacionamento) => {
        const ent = entidadePorId[relacionamento.entidade_subordinada_id]
        if (!ent) return null
        const superior = relacionamento.entidade_superior_id === null ? 'Master (direto)' : (relacionamento.nome_superior || '—')
        const identificadores = this.identificadoresPorEntidade[ent.id] || []
        const codigoEmbracon = identificadores.filter(i => i.status === 'ativo').map(i => i.codigo).join(', ')
        const filhos = (filhosPorSuperior[ent.id] || []).map(montar).filter(Boolean)
        return {
          id: ent.id,
          nome: ent.nome_fantasia,
          tipo: ent.tipo,
          razaoSocial: ent.razao_social,
          cnpj: ent.cnpj,
          status: ent.status,
          superiorNome: superior,
          cnpjMasterNome: this.cnpjNome(ent.master_cnpj_id),
          codigoEmbracon,
          relacionamentoId: relacionamento.id,
          percentuais: this.regrasAtuaisPorRelac[relacionamento.id] || [],
          filhos
        }
      }
      return (filhosPorSuperior['raiz'] || []).map(montar).filter(Boolean)
    },
    pagamentosPorCompetencia() {
      const grupos = {}
      this.pagamentos.forEach(p => {
        const chave = p.competencia || ''
        if (!grupos[chave]) grupos[chave] = { competencia: p.competencia, itens: [], totalBruto: 0, totalImposto: 0, totalLiquido: 0 }
        const bruto = parseFloat(p.valor_bruto || p.valor) || 0
        const liquido = parseFloat(p.valor) || 0
        grupos[chave].itens.push(p)
        grupos[chave].totalBruto += bruto
        grupos[chave].totalImposto += (bruto - liquido)
        grupos[chave].totalLiquido += liquido
      })
      return Object.values(grupos)
    },
    pendenciasAgrupadas() {
      const prioridade = [
        ['COD_COMISSIONADO', 'cod_comissionado', 'CÓD COMISSIONADO'],
        ['COD_EQUIPE', 'cod_equipe', 'CÓD EQUIPE'],
        ['COD_PV', 'cod_pv', 'CÓD PV'],
        ['COD_PONTO_VENDA', 'cod_ponto_venda', 'CÓD PONTO DE VENDA'],
        ['COD_FILIAL', 'codigo_filial', 'CÓD FILIAL'],
        ['CATEGORIA', 'categoria', 'CATEGORIA'],
        ['VENDEDOR', 'vendedor', 'VENDEDOR']
      ]
      const grupos = {}
      this.modalInconsist.linhas.forEach(l => {
        let tipo = null, codigo = null, rotulo = null
        for (const [t, campo, label] of prioridade) {
          if (l[campo]) { tipo = t; codigo = l[campo]; rotulo = label; break }
        }
        const chave = tipo ? (tipo + ':' + codigo) : ('semcodigo:' + l.id)
        if (!grupos[chave]) grupos[chave] = { chave, tipo, codigo, rotulo, linhas: [], total: 0, entidadeId: null }
        grupos[chave].linhas.push(l)
        grupos[chave].total += parseFloat(l.liquido_rs) || 0
      })
      return Object.values(grupos).sort((a, b) => b.linhas.length - a.linhas.length)
    }
  },
  watch: {
    masterSelecionado(v) {
      if (v) this.carregarTudoDoMaster()
    },
    mapaBusca() { this.mapaPaginaAtual = 1 },
    mapaFiltroEmpresaNome() { this.mapaPaginaAtual = 1 },
    mapaFiltroSituacao() { this.mapaPaginaAtual = 1 },
    mapaFiltroParcela() { this.mapaPaginaAtual = 1 },
    mapaLinhasPorPagina() { this.mapaPaginaAtual = 1 }
  },
  created() {
    this.carregarMasters()
  },
  mounted() {
    window.addEventListener('resize', this.recalcularLinhasOrganograma)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.recalcularLinhasOrganograma)
  },
  methods: {
    abaBtn(nome) {
      return { margin: 0, padding: '9px 16px', fontSize: '13px', fontWeight: 700, background: this.aba === nome ? '#702e46' : '#e8e8e2', color: this.aba === nome ? 'white' : '#555' }
    },
    abaBtnSecundaria(nome) {
      return { margin: 0, padding: '8px 14px', fontSize: '12px', fontWeight: 700, background: this.estruturaVista === nome ? '#702e46' : '#e8e8e2', color: this.estruturaVista === nome ? 'white' : '#555' }
    },
    abaBtnSecundaria2(nome) {
      return { margin: 0, padding: '8px 14px', fontSize: '12px', fontWeight: 700, background: this.pagamentosVista === nome ? '#702e46' : '#e8e8e2', color: this.pagamentosVista === nome ? 'white' : '#555' }
    },
    abaBtnCadastros(ativo) {
      return { margin: 0, padding: '8px 14px', fontSize: '12px', fontWeight: 700, background: ativo ? '#702e46' : '#e8e8e2', color: ativo ? 'white' : '#555' }
    },
    async abrirAbaMapa() {
      this.aba = 'mapa'
      this.mapaEmpresaDetalhe = null
      if (this.lotes.length === 0) await this.carregarLotes()
      if (!this.mapaSelecionado && this.lotes.length > 0) this.mapaSelecionado = this.lotes[0].id
      if (this.mapaSelecionado) await this.carregarLinhasMapa()
    },
    async carregarLinhasMapa() {
      this.mapaEmpresaDetalhe = null
      if (!this.mapaSelecionado) return
      const r = await apiGet('master-mapa/linhas', { mapaId: this.mapaSelecionado })
      if (r.sucesso) this.mapaLinhas = r.linhas
    },
    abrirDetalheEmpresaMapa(grupo) {
      this.mapaFiltroEmpresaNome = grupo.nome
      this.mapaVista = 'contratos'
    },
    ordenarMapaPor(campo) {
      if (this.mapaOrdenarCampo === campo) this.mapaOrdenarDir = this.mapaOrdenarDir === 'asc' ? 'desc' : 'asc'
      else { this.mapaOrdenarCampo = campo; this.mapaOrdenarDir = 'desc' }
    },
    iconeOrdenacaoMapa(campo) {
      if (this.mapaOrdenarCampo !== campo) return ''
      return this.mapaOrdenarDir === 'asc' ? ' ▲' : ' ▼'
    },
    limparFiltrosMapa() {
      this.mapaBusca = ''
      this.mapaFiltroEmpresaNome = ''
      this.mapaFiltroSituacao = ''
      this.mapaFiltroParcela = ''
      this.mapaFiltroIdentificacao = 'identificadas'
      this.mapaIncluirNaoIdentificadasNaSoma = false
    },
    alternarExpansaoLinhaMapa(l) {
      this.mapaLinhaExpandidaId = this.mapaLinhaExpandidaId === l.id ? null : l.id
    },
    mudarPaginaMapa(delta) {
      const nova = this.mapaPaginaAtual + delta
      if (nova >= 1 && nova <= this.mapaTotalPaginas) this.mapaPaginaAtual = nova
    },
    situacaoMapaTag(situacao) {
      if (situacao === 'cancelado') return { fontSize: '11px', background: '#fde8e8', color: '#c0392b', padding: '2px 8px', borderRadius: '8px', fontWeight: 700 }
      if (situacao === 'estornado') return { fontSize: '11px', background: '#fff3e0', color: '#e67e22', padding: '2px 8px', borderRadius: '8px', fontWeight: 700 }
      return { fontSize: '11px', background: '#e8f5e9', color: '#2e7d32', padding: '2px 8px', borderRadius: '8px', fontWeight: 700 }
    },
    async vincularGrupoMapa(g) {
      const entidadeId = this.mapaVincularSelecao[g.chave]
      if (!entidadeId) return
      const primeira = g.linhas[0]
      const r = await apiPost('master-mapa/resolver-linha', {
        linhaId: primeira.id,
        entidadeId,
        criarIdentificador: !!g.tipo,
        tipoIdentificador: g.tipo,
        codigo: g.codigo
      })
      if (r.sucesso) {
        delete this.mapaVincularSelecao[g.chave]
        await Promise.all([this.carregarLinhasMapa(), this.carregarLotes()])
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    async reprocessarReconhecimentoMapa() {
      const r = await apiPost('master-mapa/reconhecer', {})
      if (r.sucesso) {
        await Promise.all([this.carregarLinhasMapa(), this.carregarLotes()])
        alert(r.reconhecidas + ' linha(s) reconhecida(s) nesse reprocessamento.')
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    async abrirAbaCadastros() {
      this.aba = 'cadastros'
      await Promise.all([this.carregarRegrasDoGrafo(), this.carregarIdentificadoresTodos()])
    },
    async abrirAbaEstrutura() {
      this.aba = 'estrutura'
      await Promise.all([this.carregarRegrasDoGrafo(), this.carregarIdentificadoresTodos()])
    },
    async carregarIdentificadoresTodos() {
      const mapa = {}
      await Promise.all(this.entidades.map(async (e) => {
        const res = await apiGet('master-identificador/listar', { entidadeId: e.id })
        if (res.sucesso) mapa[e.id] = res.identificadores
      }))
      this.identificadoresPorEntidade = mapa
    },
    onEditarNo(no) {
      this.abrirModalEntidade(no.id)
    },
    abrirMenuRapido(no) {
      this.menuRapido.no = no
      this.menuRapido.aberto = true
    },
    onAdicionarSubordinado(no) {
      this.abrirModalEntidade(-1, no ? no.id : null)
    },
    onCodigoEmbracon(no) {
      const e = this.entidades.find(x => x.id === no.id)
      if (e) this.abrirModalEntidade(e.id, undefined, 'codigos')
    },
    onConfigurarComissao(no) {
      const r = this.relacionamentos.find(x => x.id === no.relacionamentoId)
      if (r) this.abrirModalRegras(r)
    },
    async verApuracaoDireto(a) {
      this.modalApuracao.lote = { arquivo: a.arquivo }
      this.modalApuracao.apuracaoId = a.id
      this.modalApuracao.valorTotal = a.valor_total
      this.modalApuracao.valorTotalLiquido = a.valor_total_liquido
      await this.carregarItensApuracao()
      this.modalApuracao.aberto = true
    },
    async mudarParaOrganograma() {
      this.estruturaVista = 'organograma'
      await this.carregarRegrasDoGrafo()
      this.$nextTick(() => setTimeout(this.recalcularLinhasOrganograma, 30))
    },
    async carregarRegrasDoGrafo() {
      const mapa = {}
      await Promise.all(this.relacionamentos.map(async (r) => {
        const res = await apiGet('master-regra/listar', { relacionamentoId: r.id })
        if (res.sucesso) {
          const vigente = res.regras.find(rg => rg.status === 'ativo') || res.regras[0]
          if (vigente) mapa[r.id] = vigente.distribuicoes.map(d => ({ nome: d.beneficiario_nome, percentual: d.percentual }))
        }
      }))
      this.regrasAtuaisPorRelac = mapa
    },
    recalcularLinhasOrganograma() {
      const wrap = this.$refs.orgWrap
      if (!wrap) return
      const caixas = wrap.querySelectorAll('[data-org-box]')
      const porId = {}
      const wrapRect = wrap.getBoundingClientRect()
      caixas.forEach(el => {
        const r = el.getBoundingClientRect()
        porId[el.getAttribute('data-entidade-id')] = {
          cx: r.left - wrapRect.left + r.width / 2,
          top: r.top - wrapRect.top,
          bottom: r.top - wrapRect.top + r.height
        }
      })
      const linhas = []
      caixas.forEach(el => {
        const paiId = el.getAttribute('data-pai-id')
        if (!paiId || paiId === 'null') return
        const pai = porId[paiId]
        const filho = porId[el.getAttribute('data-entidade-id')]
        if (!pai || !filho) return
        const pct = el.getAttribute('data-percentual')
        linhas.push({ x1: pai.cx, y1: pai.bottom, x2: filho.cx, y2: filho.top, label: pct ? (pct + '%') : '' })
      })
      this.orgLinhas = linhas
      const svg = this.$refs.orgSvg
      if (svg) { svg.setAttribute('width', wrap.scrollWidth); svg.setAttribute('height', wrap.scrollHeight) }
    },
    descendentesDe(entidadeId) {
      const filhosPorSuperior = {}
      this.relacionamentos.forEach(r => {
        const chave = r.entidade_superior_id === null ? 'raiz' : r.entidade_superior_id
        if (!filhosPorSuperior[chave]) filhosPorSuperior[chave] = []
        filhosPorSuperior[chave].push(r.entidade_subordinada_id)
      })
      const set = new Set()
      const visitar = (id) => { (filhosPorSuperior[id] || []).forEach(f => { if (!set.has(f)) { set.add(f); visitar(f) } }) }
      visitar(entidadeId)
      return set
    },
    async aplicarNovoSuperior(relacionamentoOrigemId, entidadeOrigemId, novoSuperiorId) {
      const relAtual = this.relacionamentos.find(r => r.id === relacionamentoOrigemId)
      if (!relAtual) return
      const r = await apiPost('master-relacionamento/salvar', {
        id: relacionamentoOrigemId,
        masterId: this.masterSelecionado,
        entidadeSuperiorId: novoSuperiorId,
        entidadeSubordinadaId: entidadeOrigemId,
        status: relAtual.status,
        observacoes: relAtual.observacoes
      })
      if (r.sucesso) {
        await this.carregarTudoDoMaster()
        await this.carregarRegrasDoGrafo()
        this.$nextTick(() => setTimeout(this.recalcularLinhasOrganograma, 30))
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    onSoltarNoGrafo({ entidadeOrigemId, relacionamentoOrigemId, novoSuperiorId }) {
      if (entidadeOrigemId === novoSuperiorId) return
      if (this.descendentesDe(entidadeOrigemId).has(novoSuperiorId)) { alert('Não é possível mover uma entidade para debaixo dela mesma.'); return }
      const nomeOrigem = (this.entidades.find(e => e.id === entidadeOrigemId) || {}).nome_fantasia || ''
      const destino = novoSuperiorId === null ? 'direto no Master' : ('a "' + ((this.entidades.find(e => e.id === novoSuperiorId) || {}).nome_fantasia || '') + '"')
      if (!confirm('Mover "' + nomeOrigem + '" para responder ' + destino + '? Isso altera o relacionamento real.')) return
      this.aplicarNovoSuperior(relacionamentoOrigemId, entidadeOrigemId, novoSuperiorId)
    },
    onSoltarNoRoot(e) {
      let dados = null
      try { dados = JSON.parse(e.dataTransfer.getData('text/plain')) } catch (err) { return }
      if (!dados) return
      const nomeOrigem = (this.entidades.find(x => x.id === dados.entidadeId) || {}).nome_fantasia || ''
      if (!confirm('Mover "' + nomeOrigem + '" para ficar direto no Master (sem entidade superior)? Isso altera o relacionamento real.')) return
      this.aplicarNovoSuperior(dados.relacionamentoId, dados.entidadeId, null)
    },
    cnpjNome(id) {
      const c = this.cnpjs.find(x => x.id === id)
      return c ? c.nome : '—'
    },
    async carregarMasters() {
      const r = await apiGet('master/listar')
      if (r.sucesso) {
        this.masters = r.masters
        if (this.masters.length > 0 && !this.masterSelecionado) this.masterSelecionado = this.masters[0].id
      }
    },
    async carregarTudoDoMaster() {
      const id = this.masterSelecionado
      const [rc, re, rr, rb] = await Promise.all([
        apiGet('master-cnpj/listar', { masterId: id }),
        apiGet('master-entidade/listar', { masterId: id }),
        apiGet('master-relacionamento/listar', { masterId: id }),
        apiGet('master-beneficiario/listar', { masterId: id })
      ])
      if (rc.sucesso) this.cnpjs = rc.cnpjs
      if (re.sucesso) this.entidades = re.entidades
      if (rr.sucesso) this.relacionamentos = rr.relacionamentos
      if (rb.sucesso) this.beneficiarios = rb.beneficiarios
      this.carregarLotes()
      this.carregarDashboard()
      this.carregarPagamentos()
      this.carregarRegrasDoGrafo()
      this.carregarIdentificadoresTodos()
    },
    async carregarDashboard() {
      if (!this.masterSelecionado) return
      const r = await apiGet('master-dashboard/resumo', { masterId: this.masterSelecionado })
      if (r.sucesso) this.dashboard = r.resumo
    },
    async carregarPagamentos() {
      if (!this.masterSelecionado) return
      const r = await apiGet('master-pagamento/listar', { masterId: this.masterSelecionado, mapaId: this.pagamentosFiltroMapa || '' })
      if (r.sucesso) this.pagamentos = r.pagamentos
    },
    statusPagTag(status) {
      const cores = { PENDENTE: { bg: '#fff8e1', cor: '#8a6d1d' }, APROVADO: { bg: '#e3f2fd', cor: '#1565c0' }, PAGO: { bg: '#e8f5e9', cor: '#2e7d32' }, CANCELADO: { bg: '#fde8e8', cor: '#c62828' } }
      const c = cores[status] || cores.PENDENTE
      return { fontSize: '10px', fontWeight: '700', padding: '2px 8px', borderRadius: '8px', marginLeft: '8px', background: c.bg, color: c.cor }
    },
    async mudarStatusPagamento(p, novoStatus) {
      const body = { id: p.id, status: novoStatus }
      if (novoStatus === 'PAGO') body.dataPagamento = new Date().toISOString().substring(0, 10)
      const r = await apiPost('master-pagamento/atualizar-status', body)
      if (r.sucesso) this.carregarPagamentos()
      else alert('Erro: ' + (r.mensagem || ''))
    },
    async verDemonstrativo(p) {
      const [r, rLogo] = await Promise.all([
        apiGet('master-pagamento/demonstrativo', { pagamentoId: p.id }),
        apiPublicGet('config/logo-publico', { empresa: localStorage.getItem('siscon_empresa') || '' })
      ])
      if (!r.sucesso || !r.pagamento) { alert('Erro ao gerar demonstrativo.'); return }
      const pag = r.pagamento
      const logoUrl = (rLogo && rLogo.sucesso) ? rLogo.valor : ''
      const self = this
      const porOrigem = {}
      r.itens.forEach(it => {
        const chave = it.origem_nome || '—'
        if (!porOrigem[chave]) porOrigem[chave] = []
        porOrigem[chave].push(it)
      })
      const blocos = Object.keys(porOrigem).map(nome => {
        const itens = porOrigem[nome]
        const subtotal = itens.reduce((s, it) => s + (parseFloat(it.valor_liquido) || 0), 0)
        const linhas = itens.map(it => '<tr><td>' + it.contrato + '</td><td>' + (it.nome_consorciado || '—') + '</td><td style="text-align:center;">' + it.parcela + '</td><td style="text-align:right;">' + it.percentual + '%</td><td style="text-align:right;">R$ ' + self.fmtNum(it.valor) + '</td><td style="text-align:right;">' + (it.imposto_pct > 0 ? it.imposto_pct + '%' : '—') + '</td><td style="text-align:right;font-weight:600;">R$ ' + self.fmtNum(it.valor_liquido) + '</td></tr>').join('')
        const logoEmpresa = itens[0] && itens[0].origem_logo
        return '<div class="bloco-empresa"><div class="bloco-titulo">' + (logoEmpresa ? '<img src="' + logoEmpresa + '" class="bloco-logo" />' : '') + '<span style="flex:1;">' + nome + '</span><span class="bloco-subtotal">R$ ' + self.fmtNum(subtotal) + '</span></div>' +
          '<table><thead><tr><th>Contrato</th><th>Consorciado</th><th>Parcela</th><th>%</th><th>Bruto</th><th>Imp.</th><th>Líquido</th></tr></thead><tbody>' + linhas + '</tbody></table></div>'
      }).join('')
      const iniciais = (pag.beneficiario_nome || '?').trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase()
      const statusCor = pag.status === 'PAGO' ? '#2e7d32' : pag.status === 'APROVADO' ? '#2980b9' : pag.status === 'CANCELADO' ? '#c0392b' : '#8a6d1d'
      const html = '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Recibo — ' + pag.beneficiario_nome + '</title><style>' +
        '@media print { .no-print { display:none !important; } body { padding:0 !important; } }' +
        'body{font-family:"Segoe UI",Arial,sans-serif;padding:0;margin:0;color:#302330;background:#f3f4ef;}' +
        '.folha{max-width:800px;margin:24px auto;background:#fff;border-radius:14px;overflow:hidden;box-shadow:0 2px 16px rgba(0,0,0,.08);}' +
        '.cabecalho{background:linear-gradient(135deg,#702e46,#302330);color:#fff;padding:28px 32px;display:flex;justify-content:space-between;align-items:center;}' +
        '.cabecalho .marca{display:flex;align-items:center;gap:12px;}' +
        '.cabecalho .logo-img{max-height:44px;max-width:120px;object-fit:contain;background:#fff;border-radius:6px;padding:4px 8px;}' +
        '.cabecalho h1{font-size:19px;margin:0 0 4px;font-weight:800;letter-spacing:.3px;}' +
        '.cabecalho .sub{font-size:12px;opacity:.85;}' +
        '.selo{background:rgba(255,255,255,.15);border-radius:10px;padding:8px 16px;text-align:center;}' +
        '.selo .valor{font-size:20px;font-weight:900;}' +
        '.selo .label{font-size:9px;text-transform:uppercase;letter-spacing:.08em;opacity:.8;}' +
        '.corpo{padding:28px 32px;}' +
        '.perfil{display:flex;align-items:center;gap:14px;margin-bottom:20px;padding-bottom:20px;border-bottom:1px solid #eee;}' +
        '.avatar{width:52px;height:52px;border-radius:50%;background:#efe3e8;color:#702e46;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:17px;flex-shrink:0;}' +
        '.perfil-nome{font-size:16px;font-weight:800;}' +
        '.perfil-meta{font-size:12px;color:#888;margin-top:2px;}' +
        '.status-pill{display:inline-block;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;padding:3px 10px;border-radius:10px;color:#fff;background:' + statusCor + ';margin-left:8px;}' +
        '.grid-info{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-bottom:22px;}' +
        '.info-item{background:#f7f2ee;border-radius:8px;padding:10px 12px;}' +
        '.info-item label{display:block;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#655b63;margin-bottom:3px;}' +
        '.info-item span{font-size:13px;font-weight:600;}' +
        '.bloco-empresa{margin-bottom:18px;}' +
        '.bloco-titulo{display:flex;justify-content:space-between;align-items:center;gap:8px;font-size:13px;font-weight:800;color:#702e46;background:#efe3e8;padding:8px 12px;border-radius:6px 6px 0 0;}' +
        '.bloco-logo{width:22px;height:22px;object-fit:contain;background:#fff;border-radius:4px;padding:2px;}' +
        '.bloco-subtotal{font-weight:800;}' +
        'table{width:100%;border-collapse:collapse;font-size:11.5px;}' +
        'th{background:#fafbf8;color:#655b63;padding:7px 8px;text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.03em;border-bottom:2px solid #efe3e8;}' +
        'td{padding:7px 8px;border-bottom:1px solid #f2f3ef;}' +
        '.totais{margin-top:20px;background:#f7f2ee;border-radius:10px;padding:16px 20px;}' +
        '.totais-linha{display:flex;justify-content:space-between;font-size:13px;padding:3px 0;color:#666;}' +
        '.totais-linha.final{font-size:19px;font-weight:900;color:#302330;border-top:1px solid #e0e2db;margin-top:8px;padding-top:10px;}' +
        '.rodape{text-align:center;font-size:10px;color:#aaa;padding:16px 32px 24px;}' +
        '.acoes{max-width:800px;margin:0 auto 16px;text-align:right;padding:0 24px;}' +
        '.acoes button{background:#702e46;color:#fff;border:none;padding:10px 20px;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;}' +
        '</style></head><body>' +
        '<div class="acoes no-print"><button onclick="window.print()">⬇ Baixar / Imprimir PDF</button></div>' +
        '<div class="folha">' +
        '<div class="cabecalho"><div class="marca">' + (logoUrl ? '<img class="logo-img" src="' + logoUrl + '" />' : '') + '<div><h1>' + (pag.master_nome || 'SisCon') + '</h1><div class="sub">Demonstrativo de Pagamento de Comissão' + (pag.cnpj ? ' · CNPJ ' + pag.cnpj : '') + '</div></div></div>' +
        '<div class="selo"><div class="valor">R$ ' + this.fmtNum(pag.valor) + '</div><div class="label">Líquido a receber</div></div></div>' +
        '<div class="corpo">' +
        '<div class="perfil"><div class="avatar">' + iniciais + '</div><div><div class="perfil-nome">' + pag.beneficiario_nome + '<span class="status-pill">' + pag.status + '</span></div>' +
        '<div class="perfil-meta">' + (pag.cpf_cnpj || 'CPF/CNPJ não informado') + (pag.pix_chave ? ' · PIX: ' + pag.pix_chave : '') + '</div></div></div>' +
        '<div class="grid-info">' +
        '<div class="info-item"><label>Competência</label><span>' + (pag.competencia || '—') + '</span></div>' +
        '<div class="info-item"><label>Imposto retido</label><span>' + (pag.imposto_pct > 0 ? pag.imposto_pct + '%' : 'Nenhum') + '</span></div>' +
        '<div class="info-item"><label>Emitido em</label><span>' + new Date().toLocaleDateString('pt-BR') + '</span></div>' +
        '</div>' +
        blocos +
        '<div class="totais">' +
        (pag.valor_bruto && pag.valor_bruto !== pag.valor ? '<div class="totais-linha"><span>Bruto</span><span>R$ ' + this.fmtNum(pag.valor_bruto) + '</span></div><div class="totais-linha"><span>Imposto retido</span><span>− R$ ' + this.fmtNum(pag.valor_bruto - pag.valor) + '</span></div>' : '') +
        '<div class="totais-linha final"><span>TOTAL LÍQUIDO</span><span>R$ ' + this.fmtNum(pag.valor) + '</span></div>' +
        '</div></div>' +
        '<div class="rodape">Documento gerado automaticamente pelo SisCon — módulo Master</div>' +
        '</div></body></html>'
      const w = window.open('', '_blank')
      w.document.write(html)
      w.document.close()
    },
    async gerarPagamentos() {
      if (!confirm('Gerar pagamentos consolidados por beneficiário pra esta apuração?')) return
      const r = await apiPost('master-pagamento/gerar', { apuracaoId: this.modalApuracao.apuracaoId })
      if (r.sucesso) {
        alert(r.pagamentosGerados + ' pagamento(s) gerado(s).')
        this.carregarPagamentos()
        this.aba = 'pagamentos'
        this.modalApuracao.aberto = false
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    fmtNum(v) { return (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
    iniciaisNome(nome) { return (nome || '?').trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase() },
    avatarCor(nome) {
      const paleta = [
        { bg: '#efe3e8', cor: '#702e46' },
        { bg: '#e3f2fd', cor: '#1565c0' },
        { bg: '#fff3e0', cor: '#e67e22' },
        { bg: '#fde8e8', cor: '#c0392b' },
        { bg: '#f3e8fd', cor: '#7e3fc0' },
        { bg: '#e8f5e9', cor: '#2e7d32' },
        { bg: '#fff8e1', cor: '#8a6d1d' }
      ]
      const texto = (nome || '?')
      let hash = 0
      for (let i = 0; i < texto.length; i++) hash = (hash * 31 + texto.charCodeAt(i)) >>> 0
      const c = paleta[hash % paleta.length]
      return { background: c.bg, color: c.cor }
    },

    abrirModalMaster(id) {
      this.modalMaster.id = id
      this.modalMaster.form = id === -1
        ? { nome: '', status: 'ativo', observacoes: '' }
        : { nome: this.masterAtual.nome, status: this.masterAtual.status, observacoes: this.masterAtual.observacoes }
      this.modalMaster.aberto = true
    },
    async salvarMaster() {
      if (!this.modalMaster.form.nome) { alert('Informe o nome.'); return }
      const r = await apiPost('master/salvar', { id: this.modalMaster.id, ...this.modalMaster.form })
      if (r.sucesso) {
        this.modalMaster.aberto = false
        await this.carregarMasters()
        if (this.modalMaster.id === -1 && r.id) this.masterSelecionado = r.id
      } else alert('Erro: ' + (r.mensagem || ''))
    },

    abrirModalCnpj(id) {
      this.modalCnpj.id = id
      if (id === -1) this.modalCnpj.form = { cnpj: '', nome: '', status: 'ativo', reserva_mkt_pct: 0 }
      else { const c = this.cnpjs.find(x => x.id === id); this.modalCnpj.form = { cnpj: c.cnpj, nome: c.nome, status: c.status, reserva_mkt_pct: c.reserva_mkt_pct || 0 } }
      this.modalCnpj.aberto = true
    },
    async salvarCnpj() {
      if (!this.modalCnpj.form.cnpj || !this.modalCnpj.form.nome) { alert('Preencha CNPJ e Nome.'); return }
      const r = await apiPost('master-cnpj/salvar', { id: this.modalCnpj.id, masterId: this.masterSelecionado, ...this.modalCnpj.form })
      if (r.sucesso) { this.modalCnpj.aberto = false; this.carregarTudoDoMaster() } else alert('Erro: ' + (r.mensagem || ''))
    },
    async excluirCnpj(c) {
      if (!confirm('Excluir CNPJ "' + c.nome + '"?')) return
      const r = await apiDelete('master-cnpj/excluir', { id: c.id })
      if (r.sucesso) this.carregarTudoDoMaster()
    },
    async excluirCnpjNoModal() {
      if (!confirm('Excluir CNPJ "' + this.modalCnpj.form.nome + '"?')) return
      const r = await apiDelete('master-cnpj/excluir', { id: this.modalCnpj.id })
      if (r.sucesso) { this.modalCnpj.aberto = false; this.carregarTudoDoMaster() } else alert('Erro: ' + (r.mensagem || ''))
    },

    async abrirModalEntidade(id, pendingSuperiorId, aba) {
      this.modalEntidade.id = id
      this.modalEntidade.pendingSuperiorId = pendingSuperiorId
      this.modalEntidade.aba = aba || 'dados'
      if (id === -1) this.modalEntidade.form = { nomeFantasia: '', razaoSocial: '', cnpj: '', masterCnpjId: null, tipo: 'Parceiro', status: 'ativo', observacoes: '', logoUrl: null }
      else {
        const e = this.entidades.find(x => x.id === id)
        this.modalEntidade.form = { nomeFantasia: e.nome_fantasia, razaoSocial: e.razao_social, cnpj: e.cnpj, masterCnpjId: e.master_cnpj_id, tipo: e.tipo, status: e.status, observacoes: e.observacoes, logoUrl: e.logo_url || null }
        await this.carregarIdentificadoresDaEntidade(e)
      }
      this.modalEntidade.aberto = true
    },
    selecionarLogoEntidade(e) {
      const f = e.target.files[0]
      if (!f) return
      const r = new FileReader()
      r.onload = (ev) => { this.modalEntidade.form.logoUrl = ev.target.result }
      r.readAsDataURL(f)
    },
    async salvarEntidade() {
      if (!this.modalEntidade.form.nomeFantasia) { alert('Informe o nome fantasia.'); return }
      const criando = this.modalEntidade.id === -1
      const pendingSuperiorId = this.modalEntidade.pendingSuperiorId
      const r = await apiPost('master-entidade/salvar', { id: this.modalEntidade.id, masterId: this.masterSelecionado, ...this.modalEntidade.form })
      if (!r.sucesso) { alert('Erro: ' + (r.mensagem || '')); return }
      if (criando && r.id) {
        const entidadeSuperiorId = pendingSuperiorId !== undefined ? pendingSuperiorId : null
        const rr = await apiPost('master-relacionamento/salvar', { id: -1, masterId: this.masterSelecionado, entidadeSuperiorId, entidadeSubordinadaId: r.id, status: 'ativo', observacoes: '' })
        if (!rr.sucesso) alert('Empresa criada, mas houve erro ao ligá-la na estrutura: ' + (rr.mensagem || ''))
      }
      this.modalEntidade.aberto = false
      await this.carregarTudoDoMaster()
      await Promise.all([this.carregarRegrasDoGrafo(), this.carregarIdentificadoresTodos()])
    },
    async excluirEntidade(e) {
      if (!confirm('Excluir entidade "' + (e.nome_fantasia || e.nome) + '"?')) return
      const r = await apiDelete('master-entidade/excluir', { id: e.id })
      if (r.sucesso) { await this.carregarTudoDoMaster(); await Promise.all([this.carregarRegrasDoGrafo(), this.carregarIdentificadoresTodos()]) }
      else alert('Erro: ' + (r.mensagem || ''))
    },
    async excluirEntidadeNoModal() {
      if (!confirm('Excluir empresa "' + this.modalEntidade.form.nomeFantasia + '"? Isso também remove o vínculo dela na estrutura.')) return
      const r = await apiDelete('master-entidade/excluir', { id: this.modalEntidade.id })
      if (r.sucesso) {
        this.modalEntidade.aberto = false
        await this.carregarTudoDoMaster()
        await Promise.all([this.carregarRegrasDoGrafo(), this.carregarIdentificadoresTodos()])
      } else alert('Erro: ' + (r.mensagem || ''))
    },

    async carregarIdentificadoresDaEntidade(e) {
      this.modalIdent.entidade = e
      this.novoIdent = { tipo: 'COD_COMISSIONADO', codigo: '' }
      this.presetSelecionado = null
      const r = await apiGet('master-identificador/listar', { entidadeId: e.id })
      if (r.sucesso) this.modalIdent.lista = r.identificadores
      if (!this.presets.length) await this.carregarPresets()
    },
    async abrirModalIdentificadores(e) {
      await this.carregarIdentificadoresDaEntidade(e)
      this.modalIdent.aberto = true
    },
    async carregarPresets() {
      const r = await apiGet('master-preset/listar', { masterId: this.masterSelecionado })
      if (r.sucesso) this.presets = r.presets
    },
    async aplicarPreset() {
      const preset = this.presets.find(p => p.id === this.presetSelecionado)
      if (!preset) return
      for (const item of preset.itens) {
        await apiPost('master-identificador/salvar', { entidadeId: this.modalIdent.entidade.id, tipoIdentificador: item.tipo, codigo: item.codigo })
      }
      const rl = await apiGet('master-identificador/listar', { entidadeId: this.modalIdent.entidade.id })
      if (rl.sucesso) this.modalIdent.lista = rl.identificadores
      this.carregarIdentificadoresTodos()
      alert('Grupo "' + preset.nome + '" aplicado (' + preset.itens.length + ' identificador(es)).')
    },
    async salvarPresetAtual() {
      if (!this.modalIdent.lista.length) { alert('Essa empresa ainda não tem identificadores cadastrados pra salvar como grupo.'); return }
      const nome = prompt('Nome do grupo padrão:')
      if (!nome) return
      const itens = this.modalIdent.lista.map(i => ({ tipo: i.tipo_identificador, codigo: i.codigo }))
      const r = await apiPost('master-preset/salvar', { masterId: this.masterSelecionado, nome, itens })
      if (r.sucesso) { await this.carregarPresets(); alert('Grupo salvo. Já pode aplicar em outras empresas.') }
      else alert('Erro: ' + (r.mensagem || ''))
    },
    async excluirPresetSelecionado() {
      const preset = this.presets.find(p => p.id === this.presetSelecionado)
      if (!preset || !confirm('Excluir o grupo "' + preset.nome + '"?')) return
      const r = await apiDelete('master-preset/excluir', { id: preset.id })
      if (r.sucesso) { this.presetSelecionado = null; this.carregarPresets() }
      else alert('Erro: ' + (r.mensagem || ''))
    },
    async salvarIdentificador() {
      if (!this.novoIdent.codigo) { alert('Informe o código.'); return }
      const r = await apiPost('master-identificador/salvar', { entidadeId: this.modalIdent.entidade.id, tipoIdentificador: this.novoIdent.tipo, codigo: this.novoIdent.codigo })
      if (r.sucesso) {
        this.novoIdent.codigo = ''
        const rl = await apiGet('master-identificador/listar', { entidadeId: this.modalIdent.entidade.id })
        if (rl.sucesso) this.modalIdent.lista = rl.identificadores
        this.carregarIdentificadoresTodos()
        const partes = []
        if (r.linhasReatribuidas > 0) partes.push(r.linhasReatribuidas + ' linha(s) vinculada(s) a esta empresa')
        if (r.linhasSoltas > 0) partes.push(r.linhasSoltas + ' linha(s) que não batem mais em todos os filtros voltaram pra pendente')
        if (partes.length) alert(partes.join(' · ') + '.')
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    async excluirIdentificador(i) {
      const r = await apiDelete('master-identificador/excluir', { id: i.id })
      if (r.sucesso) { this.modalIdent.lista = this.modalIdent.lista.filter(x => x.id !== i.id); this.carregarIdentificadoresTodos() }
    },

    abrirModalRelacionamento(id) {
      this.modalRelacionamento.id = id
      if (id === -1) this.modalRelacionamento.form = { entidadeSuperiorId: null, entidadeSubordinadaId: null, status: 'ativo', observacoes: '' }
      else {
        const r = this.relacionamentos.find(x => x.id === id)
        this.modalRelacionamento.form = { entidadeSuperiorId: r.entidade_superior_id, entidadeSubordinadaId: r.entidade_subordinada_id, status: r.status, observacoes: r.observacoes }
      }
      this.modalRelacionamento.aberto = true
    },
    async salvarRelacionamento() {
      if (!this.modalRelacionamento.form.entidadeSubordinadaId) { alert('Selecione a entidade subordinada.'); return }
      const r = await apiPost('master-relacionamento/salvar', { id: this.modalRelacionamento.id, masterId: this.masterSelecionado, ...this.modalRelacionamento.form })
      if (r.sucesso) { this.modalRelacionamento.aberto = false; this.carregarTudoDoMaster() } else alert('Erro: ' + (r.mensagem || ''))
    },
    async excluirRelacionamento(r) {
      if (!confirm('Excluir este relacionamento?')) return
      const res = await apiDelete('master-relacionamento/excluir', { id: r.id })
      if (res.sucesso) this.carregarTudoDoMaster()
    },

    abrirModalBeneficiario(id) {
      this.modalBeneficiario.id = id
      if (id === -1) this.modalBeneficiario.form = { nome: '', tipo: 'Parceiro', cpfCnpj: '', pixChave: '', status: 'ativo', impostoPct: 0 }
      else { const b = this.beneficiarios.find(x => x.id === id); this.modalBeneficiario.form = { nome: b.nome, tipo: b.tipo, cpfCnpj: b.cpf_cnpj, pixChave: b.pix_chave, status: b.status, impostoPct: parseFloat(b.imposto_pct) || 0 } }
      this.modalBeneficiario.aberto = true
    },
    async salvarBeneficiario() {
      if (!this.modalBeneficiario.form.nome) { alert('Informe o nome.'); return }
      const r = await apiPost('master-beneficiario/salvar', { id: this.modalBeneficiario.id, masterId: this.masterSelecionado, ...this.modalBeneficiario.form })
      if (r.sucesso) { this.modalBeneficiario.aberto = false; this.carregarTudoDoMaster() } else alert('Erro: ' + (r.mensagem || ''))
    },
    async excluirBeneficiario(b) {
      if (!confirm('Excluir beneficiário "' + b.nome + '"?')) return
      const r = await apiDelete('master-beneficiario/excluir', { id: b.id })
      if (r.sucesso) this.carregarTudoDoMaster()
    },

    fmtData(iso) { return iso ? iso.split('-').reverse().join('/') : '--' },
    async abrirModalRegras(relacionamento) {
      this.modalRegras.relacionamento = relacionamento
      this.modalRegras.editando = false
      const r = await apiGet('master-regra/listar', { relacionamentoId: relacionamento.id })
      if (r.sucesso) this.modalRegras.lista = r.regras
      this.modalRegras.aberto = true
      if (this.modalRegras.lista.filter(x => x.status === 'ativo').length === 0) this.novaRegra()
    },
    novaRegra() {
      const hoje = new Date().toISOString().substring(0, 10)
      this.formRegra = { id: -1, baseCalculo: 'liquido', vigenciaInicio: hoje, vigenciaFim: '', parcelaCondicao: '', categoriaCondicao: '', exigeSoma100: true, distribuicoes: [{ beneficiarioId: null, percentual: 0, _confirmado: false }], _avancado: false }
      this.modalRegras.editando = true
    },
    editarRegra(r) {
      this.formRegra = {
        id: r.id, baseCalculo: r.base_calculo, vigenciaInicio: r.vigencia_inicio, vigenciaFim: r.vigencia_fim || '',
        parcelaCondicao: r.parcela_condicao || '', categoriaCondicao: r.categoria_condicao || '', exigeSoma100: r.exige_soma_100,
        distribuicoes: r.distribuicoes.map(d => ({ beneficiarioId: d.beneficiario_id, percentual: parseFloat(d.percentual), _confirmado: true })),
        _avancado: !!(r.parcela_condicao || r.categoria_condicao || r.base_calculo !== 'liquido')
      }
      this.modalRegras.editando = true
    },
    nomeBeneficiario(id) {
      const b = this.beneficiarios.find(x => x.id === id)
      return b ? b.nome : '—'
    },
    confirmarDistribuicao(i) {
      const d = this.formRegra.distribuicoes[i]
      if (!d.beneficiarioId) { alert('Selecione a pessoa.'); return }
      if (!d.percentual || d.percentual <= 0) { alert('Informe um percentual maior que zero.'); return }
      d._confirmado = true
    },
    async salvarRegra() {
      if (!this.formRegra.vigenciaInicio) { alert('Informe a vigência de início.'); return }
      if (this.formRegra.distribuicoes.some(d => !d._confirmado)) { alert('Tem uma pessoa ainda não adicionada na lista. Clique em "Adicionar" nela (ou no ✕ pra remover) antes de salvar.'); return }
      const confirmadas = this.formRegra.distribuicoes.filter(d => d._confirmado)
      if (confirmadas.length === 0) { alert('Adicione pelo menos uma pessoa na distribuição.'); return }
      if (this.formRegra.exigeSoma100 && Math.abs(this.somaDistribuicao - 100) > 0.01) { alert('A soma dos percentuais é ' + this.somaDistribuicao.toFixed(2) + '%, precisa ser exatamente 100%.'); return }
      const r = await apiPost('master-regra/salvar', { relacionamentoId: this.modalRegras.relacionamento.id, ...this.formRegra, distribuicoes: confirmadas })
      if (r.sucesso) {
        if (r.aviso) alert(r.aviso)
        this.modalRegras.editando = false
        const rl = await apiGet('master-regra/listar', { relacionamentoId: this.modalRegras.relacionamento.id })
        if (rl.sucesso) this.modalRegras.lista = rl.regras
        this.carregarRegrasDoGrafo()
      } else alert('Erro: ' + (r.mensagem || r.error || 'falha desconhecida'))
    },
    async encerrarRegra(r) {
      if (!confirm('Encerrar a vigência desta regra hoje? (o histórico é preservado, não é excluído)')) return
      const res = await apiPost('master-regra/encerrar', { id: r.id })
      if (res.sucesso) {
        const rl = await apiGet('master-regra/listar', { relacionamentoId: this.modalRegras.relacionamento.id })
        if (rl.sucesso) this.modalRegras.lista = rl.regras
        this.carregarRegrasDoGrafo()
      }
    },
    async excluirRegra(r) {
      if (!confirm('Excluir esta regra definitivamente? Essa ação não pode ser desfeita.')) return
      const res = await apiPost('master-regra/excluir', { id: r.id })
      if (res.sucesso) {
        const rl = await apiGet('master-regra/listar', { relacionamentoId: this.modalRegras.relacionamento.id })
        if (rl.sucesso) this.modalRegras.lista = rl.regras
        this.carregarRegrasDoGrafo()
      } else alert('Erro: ' + (res.mensagem || ''))
    },

    async carregarLotes() {
      if (!this.masterSelecionado) return
      const [r, ra] = await Promise.all([
        apiGet('master-mapa/listar', { masterId: this.masterSelecionado }),
        apiGet('master-apuracao/listar', { masterId: this.masterSelecionado })
      ])
      if (r.sucesso) this.lotes = r.lotes
      if (ra.sucesso) this.apuracoes = ra.apuracoes
    },
    async apurarLote(l) {
      if (!confirm('Apurar este lote? Vai calcular a distribuição de comissão pra todas as linhas identificadas.')) return
      const r = await apiPost('master-apuracao/apurar', { mapaId: l.id })
      if (r.sucesso) {
        alert(r.linhasProcessadas + ' linha(s) apurada(s)' + (r.linhasSemRegra ? ', ' + r.linhasSemRegra + ' sem regra vigente aplicável.' : '.'))
        this.carregarLotes()
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    async verApuracao(l) {
      const apur = this.apuracoes.find(a => a.mapa_id === l.id)
      if (!apur) { alert('Apuração não encontrada.'); return }
      this.modalApuracao.lote = l
      this.modalApuracao.apuracaoId = apur.id
      this.modalApuracao.valorTotal = apur.valor_total
      this.modalApuracao.valorTotalLiquido = apur.valor_total_liquido
      await this.carregarItensApuracao()
      this.modalApuracao.aberto = true
    },
    async carregarItensApuracao() {
      const r = await apiGet('master-apuracao/itens', { apuracaoId: this.modalApuracao.apuracaoId })
      if (r.sucesso) { this.modalApuracao.itens = r.itens; this.modalApuracao.resumo = r.resumoPorBeneficiario }
    },
    async reprocessarApuracao() {
      if (!confirm('Reprocessar esta apuração? Os valores serão recalculados do zero com as regras vigentes em cada data.')) return
      const r = await apiPost('master-apuracao/reprocessar', { apuracaoId: this.modalApuracao.apuracaoId })
      if (r.sucesso) {
        this.modalApuracao.valorTotal = r.valorTotal
        this.modalApuracao.valorTotalLiquido = r.valorTotalLiquido
        await this.carregarItensApuracao()
        alert('Reprocessado: ' + r.linhasProcessadas + ' linha(s)' + (r.linhasSemRegra ? ', ' + r.linhasSemRegra + ' sem regra vigente.' : '.'))
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    selecionarMapa(e) {
      const f = e.target.files[0]
      if (!f) return
      this.importForm.nomeArquivo = 'Lendo...'
      this.importForm.dados = null
      const r = new FileReader()
      r.onload = (ev) => {
        const d = new Uint8Array(ev.target.result)
        const wb = window.XLSX.read(d, { type: 'array', cellDates: true })
        const sh = wb.Sheets[wb.SheetNames[0]]
        const raw = window.XLSX.utils.sheet_to_json(sh, { header: 1, defval: '', raw: false })
        this.importForm.dados = raw
        this.importForm.nomeArquivo = f.name + ' (' + (raw.length - 1) + ' reg.)'
        this.importForm._nomeOriginal = f.name
      }
      r.readAsArrayBuffer(f)
    },
    async importarMapa() {
      if (!this.importForm.dados || !this.importForm.masterCnpjId) return
      this.importando = true
      this.importStatus = 'Importando...'
      this.importStatusClasse = ''
      try {
        const r = await apiPost('master-mapa/importar', {
          masterId: this.masterSelecionado,
          masterCnpjId: this.importForm.masterCnpjId,
          nomeArquivo: this.importForm._nomeOriginal,
          competencia: this.importForm.competencia,
          dados: this.importForm.dados
        })
        if (r.sucesso) {
          this.importStatusClasse = 'sucesso'
          this.importStatus = r.totalLinhas + ' linhas importadas — ' + r.reconhecidas + ' reconhecidas automaticamente, ' + r.pendentes + ' pendentes.'
          this.importForm = { masterCnpjId: this.importForm.masterCnpjId, competencia: '', nomeArquivo: '', dados: null }
          this.carregarLotes()
        } else {
          this.importStatusClasse = 'erro-msg'
          this.importStatus = 'Erro: ' + (r.mensagem || '')
        }
      } finally {
        this.importando = false
      }
    },
    async abrirForaCondicao(lote) {
      this.modalForaCondicao.lote = lote
      const r = await apiGet('master-mapa/linhas', { mapaId: lote.id, status: 'fora_condicao' })
      if (r.sucesso) this.modalForaCondicao.linhas = r.linhas
      this.modalForaCondicao.aberto = true
    },
    async abrirInconsistencias(lote) {
      this.modalInconsist.lote = lote
      const r = await apiGet('master-mapa/linhas', { mapaId: lote.id, status: 'pendente' })
      if (r.sucesso) this.modalInconsist.linhas = r.linhas.map(l => ({ ...l, _entidadeId: null, _tipoCodigo: '' }))
      this.modalInconsist.aberto = true
    },
    async resolverLinha(l) {
      const campoPorTipo = { COD_COMISSIONADO: 'cod_comissionado', COD_EQUIPE: 'cod_equipe', COD_PV: 'cod_pv', COD_PONTO_VENDA: 'cod_ponto_venda', COD_FILIAL: 'codigo_filial', CATEGORIA: 'categoria', VENDEDOR: 'vendedor' }
      const r = await apiPost('master-mapa/resolver-linha', {
        linhaId: l.id,
        entidadeId: l._entidadeId,
        criarIdentificador: !!l._tipoCodigo,
        tipoIdentificador: l._tipoCodigo,
        codigo: l._tipoCodigo ? l[campoPorTipo[l._tipoCodigo]] : ''
      })
      if (r.sucesso) {
        this.modalInconsist.linhas = this.modalInconsist.linhas.filter(x => x.id !== l.id)
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    async resolverGrupo(g) {
      const r = await apiPost('master-mapa/resolver-linha', {
        linhaId: g.linhas[0].id,
        entidadeId: g.entidadeId,
        criarIdentificador: !!g.tipo,
        tipoIdentificador: g.tipo || '',
        codigo: g.codigo || ''
      })
      if (r.sucesso) {
        const ids = new Set(g.linhas.map(l => l.id))
        this.modalInconsist.linhas = this.modalInconsist.linhas.filter(l => !ids.has(l.id))
        this.carregarLotes()
      } else alert('Erro: ' + (r.mensagem || ''))
    },
    fecharInconsistenciasEAtualizar() {
      this.modalInconsist.aberto = false
      this.carregarLotes()
    },
    async excluirLote(l) {
      if (!confirm('Excluir o lote "' + l.arquivo + '" e todas as suas linhas?')) return
      const r = await apiDelete('master-mapa/excluir', { id: l.id })
      if (r.sucesso) this.carregarLotes()
      else alert('Erro: ' + (r.mensagem || ''))
    }
  }
}
</script>
